{
    "APPLICATION_NAME": "RASK",
    "ABOUT_BUILDNUMBER": "Version",
    "ABOUT_DESCRIPTION": "Nedan listas alla ingående tredjepartskomponenter för klienten med tillhörande licensvillkor.",
    "ABOUT_HEADER": "Om RASK",
    "FUNCTIONS_HEADER": "Funktioner",
    "ABOUT_PUBLISHDATE": "Publicerad",
    "ABOUT_RELEASEID": "ReleaseId",
    "ABOUT_ROLES": "Roller",
    "ABOUT_TROUBLESHOOTING": "Felsökningsinformation",
    "ADMINISTRATION_NAVET_HEADER": "Navet",
    "ADMINISTRATION_BASLADDA_ATGARDER_HEADER": "Åtgärder från Navet",
    "ADMINISTRATION_BASLADDA_ATGARDER_INKLUDERA_GEOEXTRACT": "Inkludera omladdning av geoextract",
    "ADMINISTRATION_BASLADDA_ATGARDER_LABEL": "Basladda alla åtgärder",
    "ADMINISTRATION_BASLADDA_ATGARDER_RESULTAT": "{{ antalAtgarder }} åtgärder lades på kö för inläsning.",
    "ADMINISTRATION_BASLADDA_UPDATEAVDELNIG_HEADER": "Uppdatera avdelning",
    "ADMINISTRATION_BASLADDA_UPDATEAVDELNING_LABEL": "Avdelning Guid (,)",
    "ADMINISTRATION_BASLADDA_UPDATEAVDELNIG_LABEL": "Uppdatera",
    "ADMINISTRATION_BASLADDA_UPDATEAVDELNIG_RESULTAT": "{{ antalAvdelningChanged }} avdelning lades på kö för inläsning.",
    "ADMINISTRATION_FEATURE_TOGGLING_HEADER": "Feature toggling",
    "ADMINISTRATION_FEATURE_TOGGLING_LIST_ACTIVE": "Aktiv",
    "ADMINISTRATION_FEATURE_TOGGLING_LIST_NAME": "Namn",
    "ADMINISTRATION_FEATURE_TOGGLING_LIST_TYPE": "Typ",
    "ADMINISTRATION_HEADER": "Administration",
    "ADMINISTRATION_LAGERSALDO_PROLOG_CARD_LABEL": "Hämta lagersaldo från Prolog för en specifik lagerplats eller alla (lämna Lagerplats Id fältet tomt)",
    "ADMINISTRATION_LAGERSALDO_PROLOG_HEADER": "Lagersaldo Prolog",
    "ADMINISTRATION_LAGERSALDO_PROLOG_LABEL": "Lagerplats Id",
    "ADMINISTRATION_KRONT_VAGVAL_LABEL": "Krönt vägval",
    "ADMINISTRATION_KRONT_VAGVAL_BETECKNING": "Beteckning",
    "ADMINISTRATION_KRONT_VAGVAL_SASONG_SOMMAR": "Sommar",
    "ADMINISTRATION_KRONT_VAGVAL_SASONG_VINTER": "Vinter",
    "ADMINISTRATION_VIRKESORDER": "Virkesorder",
    "ADMINISTRATION_SKORDNING": "Skördning påbörjad",
    "ADMINISTRATION_MATMASTER": "Mätmaster",
    "ADMINISTRATION_MATMASTER_LEVERANSMATNINGTOLKNING": "Omkörning leveransmätningstolkning och omsändning",
    "ADMINISTRATION_MATMASTER_MATNINGSDATUM_FROM": "Mätningsdatum fr.o.m.",
    "ADMINISTRATION_MATMASTER_MATNINGSDATUM_TOM": "Mätningsdatum t.o.m.",
    "ADMINISTRATION_MATMASTER_OMKORNINGOMSANDNING": "Omkörning/Omsändning",
    "ADMINISTRATION_MATMASTER_OMSÄNDNING": "Omsändning",
    "ADMINISTRATION_MATMASTER_OMSÄNDNINGLEVERANSMATNINGAR": "Omsändning av leveransmätningar",
    "ADMINISTRATION_MATMASTER_TRANSAKTIONSDATUM_FROM": "Transaktionsdatum fr.o.m.",
    "ADMINISTRATION_MATMASTER_TRANSAKTIONSDATUM_TOM": "Transaktionsdatum t.o.m.",
    "ADMINISTRATION_PRODUKTINSTRUKTIONER_GETALLPRODUKTINSTRUKTIONER": "Basladda alla produktinstruktioner",
    "ADMINISTRATION_PRODUKTINSTRUKTIONER_HEADER": "Produktinstruktioner",
    "ADMINISTRATION_PRODUKTINSTRUKTIONER_UPDATED_COUNT": "{{ updatedProduktinstruktioner }} produktinstruktion(er) uppdaterade.",
    "ADMINISTRATION_PRODUKTINSTRUKTIONER_ADDED_COUNT": "{{ addedProduktinstruktioner }} produktinstruktion(er) importerade.",
    "ADMINISTRATION_VACS_HEADER": "VACS",
    "ADMINISTRATION_VACS_EXPORTERA_VACSKONTRAKT_HEADER": "Exportera XML",
    "ADMINISTRATION_VACS_EXPORTERA_VACSKONTRAKT__KONTRAKTSNUMMER_LABEL": "Kontraktsnummer",
    "ADMINISTRATION_VACS_EXPORTERA_VACSKONTRAKT_LABEL": "Exportera XML från VACS Kontrakt",
    "ADMINISTRATION_ARBETSORDER": "Arbetsorder",
    "ADMINISTRATION_ARBETSORDER_DISTRIKT_HEADER": "Starta omladdning av Distrikt för Arbetsorder",
    "ADMINISTRATION_ARBETSORDER_DISTRIKT_SUCCESS": "Schemaläggning för omladdning av Distrikt för Arbetsorder är startad",
    "ADMINISTRATION_ARBETSORDER_DISTRIKT_ERROR": "Misslyckades att skapa schemaläggning för omladdning av Distrikt för Arbetsorder",
    "ANVANDARE_COLUMN_ANSTALLD": "Anställd",
    "ANVANDARE_COLUMN_ANV_ID": "Användar-id",
    "ANVANDARE_COLUMN_EFTERNAMN": "Efternamn",
    "ANVANDARE_COLUMN_FORNAMN": "Förnamn",
    "ANVANDARE_COLUMN_NAMN": "Namn",
    "ANVANDARE_COLUMN_LAST": "Låst",
    "ANVANDARE_DETAIL_EDITERA": "Användare",
    "ANVANDARE_DETAIL_SKAPA_NY": "Skapa ny användare",
    "ANVANDARE_EPOST_VALIDATION": "Email saknas",
    "ANVANDARE_HEADER": "Användare",
    "ANVANDARE_LABEL_ANVANDARE": "Användare",
    "ANVANDARE_LABEL_GRUPPER": "Grupper",
    "ANVANDARE_LABEL_ANSTALLD": "Anställningstyp",
    "ANVANDARE_LABEL_ANSTALLD_JA": "Enbart Anställda",
    "ANVANDARE_LABEL_ANSTALLD_NEJ": "Alla",
    "ANVANDARE_LABEL_ANV_ID": "Användar-id",
    "ANVANDARE_LABEL_CULTURE": "Språk",
    "ANVANDARE_LABEL_EFTERNAMN": "Efternamn",
    "ANVANDARE_LABEL_EPOST": "E-post",
    "ANVANDARE_LABEL_ESKALERING_SAKNAS": "Du måste ha eskalerad behörighet för att skapa eller editera användare",
    "ANVANDARE_LABEL_FORNAMN": "Förnamn",
    "ANVANDARE_LABEL_LAST": "Låst",
    "ANVANDARE_LABEL_MOBIL": "Mobiltelefon",
    "ANVANDARE_LABEL_SKAPA_ANVANDARE": "Skapa ny Användare",
    "ANVANDARE_LABEL_SYSTEMTILLHORIGHET": "Systemtillhörighet",
    "ANVANDARE_LABEL_DISTRIKTSKOD": "Distriktskod",
    "ANVANDARE_LIST_SOK": "Sök användare",
    "ANVANDARE_MOBIL_VALIDATION": "Mobil saknas",
    "ANVANDARE_USERNAME_VALIDATION": "Användarnamn saknas",
    "ANVANDARE_DISTRIKTSKOD_VALIDATION": "Fel format, distrikskod är två siffror",
    "ANVANDARE_SYSTEMTILLHORIGHET_VALIDATION": "Fyll i namn eller användar-ID för att söka på Alla",
    "AREA_SELECTOR_PLACEHOLDER": "Välj område",
    "BUSY_WAIT": "Vänta...",
    "CHARACTERS_LEFT": "tecken kvar",
    "DEFAULT_ANTAL_RESULTAT": "Sökresultat: {{antal}} träffar",
    "DEFAULT_ANTAL_RESULTAT_ONE": "Sökresultat: 1 träff",
    "DEFAULT_BUTTON_LABEL_ANDRA": "Ändra",
    "DEFAULT_BUTTON_LABEL_AVBRYT": "Avbryt",
    "DEFAULT_BUTTON_LABEL_DELETE": "Ta bort",
    "DEFAULT_BUTTON_LABEL_EDIT": "Redigera",
    "DEFAULT_BUTTON_LABEL_EXCELEXPORT": "Exportera till Excel",
    "DEFAULT_BUTTON_LABEL_LAGG_TILL": "Lägg till",
    "DEFAULT_BUTTON_LABEL_NY": "ny",
    "DEFAULT_BUTTON_LABEL_NYTT": "nytt",
    "DEFAULT_BUTTON_LABEL_OK": "Ok",
    "DEFAULT_BUTTON_LABEL_RADERA": "Ta bort",
    "DEFAULT_BUTTON_LABEL_RENSA": "Rensa",
    "DEFAULT_BUTTON_LABEL_SKAPA": "Skapa",
    "DEFAULT_BUTTON_LABEL_SOK": "Sök",
    "DEFAULT_BUTTON_LABEL_SPARA": "Spara",
    "DEFAULT_BUTTON_LABEL_SPARAD": "Sparad",
    "DEFAULT_BUTTON_LABEL_UPPDATERA": "Uppdatera",
    "DEFAULT_BUTTON_LABEL_VISA": "Visa",
    "DEFAULT_BUTTON_LABEL_YES": "Ja",
    "DEFAULT_BUTTON_LABEL_NO": "Nej",
    "DEFAULT_BUTTON_LABEL_OMKORNING": "Omkörning",
    "DEFAULT_CREATE_SUCCESS": "Objektet skapades",
    "DEFAULT_CHANGE_SUCCESS": "Ändringarna sparades",
    "DEFAULT_DELETION_SUCCESS": "Borttagning lyckades",
    "CREATE_GROTKONTRAKT_SUCCESS": "Grotkontrakt skapades",
    "DEFAULT_DATEPICKER_CLEAR": "Rensa",
    "DEFAULT_DATEPICKER_CLOSE": "Stäng",
    "DEFAULT_DATEPICKER_CURRENT": "Idag",
    "DEFAULT_DOLJ": "Dölj",
    "DEFAULT_DOLJ_AVANCERATFILTER": "Dölj avancerat sökfilter",
    "DEFAULT_DOLJ_DETALJER": "Dölj detaljer",
    "DEFAULT_DOLJ_LOGG": "Dölj logg",
    "DEFAULT_EXCEL_PASTE_STOR_MANGD_HEADER": "Fler celler än matrisen innehåller",
    "DEFAULT_EXCEL_PASTE_STOR_MANGD_TEXT": "Det går inte att klistra in fler celler än vad matrisen innehåller",
    "DEFAULT_EXIT_FULLSCREEN": "Avsluta fullskärm",
    "DEFAULT_FALT_OBLIGATORISKT": "* = Obligatoriskt",
    "DEFAULT_FROM": "fr.o.m.",
    "DEFAULT_TOM": "t.o.m.",
    "DEFAULT_GILTIG_FROM": "Giltig fr.o.m.",
    "DEFAULT_GILTIG_TOM": "Giltig t.o.m.",
    "DEFAULT_GILTIGHET": "Giltighet",
    "DEFAULT_GILTIGHETSTIDFROM": "Giltighetstid fr.o.m.",
    "DEFAULT_GILTIGHETSTIDTOM": "Giltighetstid t.o.m.",
    "DEFAULT_GREATER_EQUALS": ">=",
    "DEFAULT_HOTKEYS_CONTROL_S": "(Ctrl+S)",
    "DEFAULT_HOTKEYS_HEADLINE": "Kortkommandon",
    "DEFAULT_HOTKEYS_HELPMENU": "Visa / dölj hjälpmeny",
    "DEFAULT_HOTKEYS_SAVE": "Spara",
    "DEFAULT_INGEN_DATA": "Ingen data hittades",
    "DEFAULT_LABEL_ALLA": "Alla",
    "DEFAULT_LABEL_INSTALLNINGAR": "Inställningar",
    "DEFAULT_LABEL_AV": "av",
    "DEFAULT_LABEL_CM": "cm",
    "DEFAULT_LABEL_JA": "Ja",
    "DEFAULT_LABEL_LANK": "Länk",
    "DEFAULT_LABEL_MAX": "Max",
    "DEFAULT_LABEL_MIN": "Min",
    "DEFAULT_LABEL_NEJ": "Nej",
    "DEFAULT_LABEL_OK": "Ok",
    "DEFAULT_LABEL_SKAPA": "Skapa",
    "DEFAULT_LABEL_SYSTEMTILLHORIGHET_JA": "Enbart Raskanvändare",
    "DEFAULT_LABEL_SYSTEMTILLHORIGHET_NEJ": "Alla",
    "DEFAULT_LABEL_TILLBAKA": "Tillbaka",
    "DEFAULT_LABEL_VISA": "Visa",
    "DEFAULT_LABEL_HAMTA": "Hämta",
    "DEFAULT_LAGER": "Lager",
    "DEFAULT_LESS_EQUALS": "<=",
    "DEFAULT_LINK_LABEL_DETAIL": "Öppna",
    "DEFAULT_LINK_LABEL_HANTERA": "Hantera",
    "DEFAULT_LINK_LABEL_INAKTIV": "(inaktiv)",
    "DEFAULT_LINK_LABEL_SOK_LISTA": "Sök och lista",
    "DEFAULT_LINK_LABEL_SOK_LISTA_REDIGERA": "Sök, lista och redigera",
    "DEFAULT_OGILTIGT_DATUM": "Ogiltigt datum",
    "DEFAULT_OGILTIGT_NUMMER": "Ogiltigt nummer",
    "DEFAULT_PERIODFROM": "Gäller fr.o.m.",
    "DEFAULT_PERIODTOM": "Gäller t.o.m.",
    "DEFAULT_SELECT_AREA": "Område",
    "DEFAULT_SELECT_LAGERENHET": "Välj lagerenhet",
    "DEFAULT_SELECT_PRODUKT": "Välj produkt",
    "DEFAULT_SELECT_PRODUKTGRUPP": "Välj produktgrupp",
    "DEFAULT_START_FULLSCREEN": "Fullskärm",
    "DEFAULT_SWEREF99": "SWEREF99",
    "DEFAULT_TYPE_AHEAD_HELP_TEXT": "Ange minst tre tecken",
    "DEFAULT_TYPE_AHEAD_NO_RESULT": "Inget resultat",
    "DEFAULT_UNDO_BUTTON_ANGRA": "Ångra ändringar",
    "DEFAULT_UNDO_BUTTON_PROMPT_NO": "Nej, avbryt",
    "DEFAULT_UNDO_BUTTON_PROMPT_YES": "Ja, ångra ändringar",
    "DEFAULT_UNDO_PROMPT_HEADER": "Vill du ångra alla ändringar?",
    "DEFAULT_UNDO_PROMPT_TEXT": "Dina ändringar kommer inte att sparas. Välj Nej, avbryt om du vill stanna kvar på sidan så att du kan spara dina ändringar.",
    "DEFAULT_VALD": "Vald",
    "DEFAULT_VALJ": "Välj",
    "DEFAULT_VISA": "Visa",
    "DEFAULT_NAMN": "Namn",
    "DEFAULT_TA_BORT": "Ta bort",
    "DEFAULT_SENAST_ANDRAD": "Senast ändrad",
    "DEFAULT_VISA_AVANCERATFILTER": "Visa avancerat sökfilter",
    "DEFAULT_VISA_DETALJER": "Visa detaljer",
    "DEFAULT_VISA_LOGG": "Visa logg",
    "DEFAULT_SENAST_HAMTAT": "Senast hämtat kl {{tidpunkt}}",
    "DEFAULT_OCH": "och",
    "DIALOGS_CLOSE": "Stäng",
    "DIALOGS_NO": "Nej",
    "DIALOGS_OK": "OK",
    "DIALOGS_YES": "Ja",
    "DOMAIN_RESULTATOMRADE": "Region",
    "ERROR_FEATURE_INACTIVATED": "Sida inaktiverad",
    "ERROR_FEATURE_INACTIVATED_DESCRIPTION": "Sidan du försöker nå är inaktiverad. Kontakta supporten för att få hjälp!",
    "ERROR_HEADER": "Fel",
    "ERROR_INVALID_URL": "Felaktig länk",
    "ERROR_INVALID_URL_DESCRIPTION": "Länken du angav finns inte.",
    "ERROR_PERMISSION_DENIED": "Behörighet saknas",
    "ERROR_PERMISSION_DENIED_DESCRIPTION": "Du saknar behörighet till sidan du försökte gå till. Kontakta supporten för att få hjälp!",
    "ERROR_PERMISSION_TO_RASK_DENIED": "Behörighet till Rask saknas",
    "ERROR_PERMISSION_TO_RASK_DENIED_DESCRIPTION": "Du saknar behörighet till Rask. Vänligen kontakta Sveaskogs IT-support på IT-support@sveaskog.se eller 08-65 591 50 för att få hjälp!",
    "EXTERNVIRKESKOP_HEADER": "Importerade kontrakt",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_HANDELSSORTIMENT": "Handelssortiment",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_MOTTAGNINSPLATS": "Mottagningsplats",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_AVLASTNINGSPLATS": "Avlpts",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_LAGERPLATS": "Lagerplats",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_MO_RO_PO": "Mo/Ro/Po",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_ANSKAFFNINGSFORM": "Anskaffningsform",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_AFFARSFORM": "Affärsform",
    "EXTRA_MOTTAGNINGS_PLATSER_LIST_AVVERKNINGSFORM": "Avv.form",
    "EXTRA_MOTTAGNINGS_PLATSER_BUTTON_LAGG_TILL": "Lägg till ny rad",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSFORM_CHANGE_TITLE": "Förändring av affärsform",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSFORM_CHANGE_MESSAGE": "Vid byte av affärsform kan information gå förlorad. Välj nej för att återställa valet.",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSFORM_CHANGE_ACCEPT_CHANGES": "Ändra affärsform",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSFORM_TOOLTIP_L1": "Affärsform kan inte ändras då kontraktet har skickats till VACS eller då ingående åtgärders arbetsorder har produktionsstatus Pågår. Du kan skapa ett nytt kontrakt på samma avtal istället.",
    "VIRKESKOP_ANBUD_KONTRAKT_TYP_CHANGE_ACCEPT_CHANGES": "Ändra kontraktstyp",
    "VIRKESKOP_ANBUD_KONTRAKT_TYP_CHANGE_MESSAGE": "Vid byte av kontraktstyp kan information gå förlorad. Välj nej för att återställa valet.",
    "VIRKESKOP_ANBUD_KONTRAKT_TYP_CHANGE_TITLE": "Förändring av kontraktstyp",
    "VIRKESKOP_ANBUD_KONTRAKT_NETTOTYP": "Nettotyp",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSTYP_SORTIMENTSNETTO": "Sortimentsnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_AFFARSTYP_SNITTNETTO": "Snittnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_ANTECKNINGAR": "Anteckningar",
    "VIRKESKOP_ANBUD_KONTRAKT_ANTECKNINGAR_AVVERKNINGSDIREKTIV": "Kontraktsanteckningar avverkningsdirektiv",
    "VIRKESKOP_ANBUD_KONTRAKT_ANTECKNINGAR_TRANSPORTORDER": "Kontraktsanteckningar transportorder",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARDSGRUPP": "Åtgärdsgrupp",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARDSTYP": "Åtgärdstyp",
    "VIRKESKOP_ANBUD_KONTRAKT_ANTECKNING": "Anteckning",
    "VIRKESKOP_ANBUD_KONTRAKT_AREAL": "Areal",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_ATGARD_INFOPOPUP": "En komplett åtgärd krävs för varje virkesorder som ska skapas. Det är åtgärdernas volym och tid som visas upp i produktionsplanering, som stöd för att balansera produktionen.",
    "VIRKESKOP_ANBUD_KONTRAKT_IMPORTERA_TILL": "Importera till",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_DELETE_TITLE": "Är du säker på att du vill ta bort åtgärden?",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_DELETE_MESSAGE": "Tänk på att åtgärdens alla uppgifter tas bort från kontraktet. Välj nej för att behålla åtgärden.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_DELETE_ACCEPT_CHANGES": "Ta bort åtgärd",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_AKEDJA": "Akedja",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_NETTOHA": "Netto ha",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_NVBEDOMNING": "Nv-bedöm.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_NVBEDOMNING_TOOLTIP": "Nv-bedömning",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_PLANSTATUS": "Planeringsstatus",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_VOLYM": "Volym",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM": "f. produktionsdatum",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM_FROM": "f. produktionsdatum fr.o.m.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM_TOM": "f. produktionsdatum t.o.m.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM_TOOLTIP": "Föreslaget produktionsdatum",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM_FROM_TOOLTIP": "Förväntat startdatum:",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_FORESLAGETPRODUKTIONSDATUM_TOM_TOOLTIP": "Förväntat slutdatum:",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_AVLAGG": "Avlägg",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_HEADER_LARMKOORDINAT": "Larmkoordinat",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TRANSPORTORDER_ANTECKNING": "Åtgärdsanteckning transportorder",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_NETTOHA": "Nettoareal ha",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_NETTOHA_KORTNAMN": "ha",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TA_BORT": "Ta bort åtgärd",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_INGAR_I_ARBETSORDER": "Ingår i arbetsorder",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_RELATERAD_ATGARD": "Relaterad åtgärd",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_RELATERAD_KONTRAKT": "Relaterat kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER": "Detaljer",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_ANTALFS": "Antal F/S per ha",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_ANTECKNINGAR": "Anteckning till arbetsorder",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_BARIGHET": "Bärighet",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_TILLGANGLIGHET_VAG": "Tillgänglighet Väg",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_GROTUTTAGFORESLAGET": "GROT-uttag",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_SKAPA_GROTKONTRAKT_FROM_KONTRAKT": "Skapa grotkontrakt från detta kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_UPPDATERA_KONTRAKT": "Uppdatera information från kopplat kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_LUTNING": "Lutning",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_TILLGANGLIGHET_SKOG": "Tillgänglighet Skog",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_MEDELSTAM": "Medelstam m3f/stam",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_SKOTNINGSAVSTAND": "Skotningsavstånd meter",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_LEVERANSPLAN": "Leveransvirkesplan",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_TRANSPORT_DRIVNINGSPUNKTER": "Drivningspunkter",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_TRANSPORT_DRIVNINGSPUNKTER_TOOLTIP": "För att verifiera åtgärderns drivningspunkter behöver det finnas:",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_TRANSPORT_DRIVNINGSPUNKTER_TOOLTIP_HTML_LARMKOORDINAT": "Endast en larmkoordinat",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_TRANSPORT_DRIVNINGSPUNKTER_TOOLTIP_HTML_AVLAGG": "Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_STATUS": "Status",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_STATUS_PRODUKTIONSSTATUS": "Produktionsstatus",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_TRANSPORT": "Transport",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_DETALJER_YTSTRUKTUR": "Ytstruktur",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_TAB_FORKALKYL": "Förkalkyl",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_UTTAGSANVISNING": "Uttagsanvisning avverkningsdirektiv",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_AVVERKNING_DATUM_ERROR": "Åtgärden kan inte göras tillgänglig innan datum då avverkning får starta har inträffat",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_AVVERKNINGANMALAN_UTFORD_DATUM_ERROR": "Felaktigt datum på Anmalan utförd.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_AVVERKNINGANMALAN_FARSTARTA_DATUM_ERROR": "Felaktigt datum på Avverkning får starta",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_PRODUKTION_DATUM_ERROR": "Senaste produktionsplandatum får inte vara före tidigaste produktionsplandatum",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_ERROR_FORESLAGETPRODUKTIONSDATUM_TOO_EARLY": "Första produktionsdatum får inte vara före kontraktets giltighet eller efter sista produktionsdatum.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARD_ERROR_FORESLAGETPRODUKTIONSDATUM_TOO_LATE": "Sista produktionsdatum får inte vara före första produktionsdatum eller efter kontraktets giltighet",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING": "Betalning",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BETALNINGAR": "Betalningar kr",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_PROCENTAVBELOPP": "% av kontraktsbelopp",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_KONTRAKTSBELOPP": "Kontraktsbelopp kr",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_LAGG_UPP": "Lägg upp betalning",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_MARKAGARE": "Markägare - Andel",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_PROCENT_AV_ANDEL": "% av andel",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_ANDEL_KR": "Andel kr",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_PERSONORGNR": "Pnr/org nr",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BETALUPPGIFTER": "Betaluppgifter",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_LAGG_TILL": "Lägg till betalning",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_KREDIT": "Kredit",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BETALNING": "Betalning",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BELOPP_EX_MOMS_KR": "Belopp ex moms kr",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_RESTERANDE": "Resterande",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BETALDATUM": "Betaldatum",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_TA_BORT": "Ta bort",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_BELOPP_EX_MOMS": "Belopp exkl moms",
    "VIRKESKOP_ANBUD_KONTRAKT_BETALNING_NASTA": "Nästa",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER": "Tillagda filer",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LADDA_UP": "Ladda upp",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LAGG_TILL_BILAGA": "Välj eller drag och släpp fil (pdf, docx, doc, xls, xlsx, txt, msg, jpg, jpeg, png)",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LAGG_TILL_BILAGA_SVP": "Observera att filen inte automatiskt laddas över till Skogsvårdsportalen. Välj eller drag och släpp fil (pdf, docx, doc, xls, xlsx, txt, msg, jpg, jpeg, png)",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_TA_BORT_BILAGA": "Ta bort fil",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_MAX_UPLOAD_STORLEK": "Filen är för stor. Max 50MB",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_MAX_FILNAMN_STORLEK": "Kan inte ladda upp filer med namn som överskrider 100 tecken",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_TILLATNA_FILTYPER": "Välj en korrekt filtyp (pdf, docx, doc, xls, xlsx, txt, msg)",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT": "Certifiering",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT_TYP_AV_CERTIFIKAT": "Typ av certifikat",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT_PEFC": "PEFC",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT_FSC": "FSC",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT_NAMN_NUMMER": "Nummer & namn",
    "VIRKESKOP_ANBUD_KONTRAKT_CERTIFIKAT_GILTIGHETSKONTOLL": "Datum för giltighetskontroll",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_HEADER_REDIGERA_ANBUD_KONTRAKT": "Redigera avtal",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_HEADER_SKAPA_ANBUD_KONTRAKT": "Skapa avtal",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_HEADER_ALLMAN_INFORMATION": "Allmän information",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_REDAN_VALD": "är redan vald",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_KOMMER_INTE_KUNNA_ANDRAS": "Leverantörer för något av kontrakten i avtalet kommer inte kunna uppdateras om du skickar detta till VACS. Vill du fortsätta?",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_KOMMER_INTE_KUNNA_ANDRAS_TITEL": "Skicka kontrakt till VACS",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_LABEL_ADRESS": "Adress",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_LABEL_FRISOK": "Sök i leverantörsregistret",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_LABEL_SOK_LEVERANTOR": "Sök leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_LABEL_POSTNUMMER": "Postnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_LABEL_TELEFONNUMMER": "Telefonnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_PLCEHOLDER_FRISOK": "Namn, ort eller pnr/org-nr",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_INGEN_LEVERANTOR_HITTAD": "Kunde inte hittas",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_STEG1_INGEN_LEVERANTOR_HITTAD_DETAIL": "Det finns ingen leverantör som matchar din sökning. Kontrollera stavningen/numret eller prova andra sökkriterier. ",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKAPA_NY_LEVERANTOR": "Skapa ny leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE": "Anbudsleverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_SAKNAS_TOOLTIP": "Om leverantören saknas i registret ska en anbudsleverantör läggas till och användas tillfälligt i anbudsfasen. Vid skapande av kontrakt krävs sedan att anbudsleverantören läggs upp som leverantör i Lime.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_KONTRAKT_LEVERANTOR_SAKNAS": "Leverantören hittades inte. Lägg till leverantören i Lime eller kontrollera numret.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_KONTRAKT_LEVERANTOR_PERSNR_SAKNAS": "Personnummer eller organisationsnummer krävs för att hämta leverantören från Lime.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_KONTRAKT_LEVERANTOR_FINNS": "Leverantör finns i leverantörsregistret.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_KONTRAKT_LEVERANTOR_FINNS_EFFEKT": "Spara för att lägga till leverantör på avtalet.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_LAGG_TILL_SKOGSAGARE": "Lägg till anbudsleverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_NAMN": "Namn",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_PERSONORGANISATIONSNUMMER": "Person-/Organisationsnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKOGSAGARE_PERSONORGANISATIONSNUMMER_FINNS_REDAN": "Fler än en leverantör med detta personnummer / organisationsnummer hittades. Ta bort anbudsleverantören och välj leverantör direkt från leverantörsregistret.",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_ANBUD_OCH_KONTRAKT": "Anbud och kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_FELMEDDELANDE_ANSVARIG_VIRKESKOPARE": "Ansvarig virkesköpare saknas",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_FELMEDDELANDE_MINST_EN_LEVERANTOR": "Minst en leverantör krävs",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_AFFARSFORM": "Affärsform",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_AFFARSFORM_REQUIRED": "Du måste ange affärsform",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_AFFARSFORMATGARD_ERROR": "För att byta till affärsformen {{affarsform}} behöver du ta bort de skapade åtgärderna",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_SKORDARMATNING": "Ska skördarmätas",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_LEVERANTORANSVARARAVVERKNINGSANMÄLAN": "Leverantör ansvarar för avverkningsanmälan",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_ANSVARIG_VIRKESKOPARE": "Ansvarig virkesköpare",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_AVTALSNUMMER": "Avtalsnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_ANSKAFFNINGSFORM": "Anskaffningsform",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_AVTALSSTATUS": "Avtalsstatus",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_BENAMNING_AVTAL": "Benämning avtal",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_BENAMNING_KONTRAKT": "Benämning kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_BUTTON_SKAPA": "anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_KONTRAKTNUMMER": "Kontraktnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_KONTRAKTSTYP": "Kontraktstyp",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_LABEL_KONTRAKTSTATUS": "Kontraktstatus",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_STATUS_REQUIRES_LEVERANTOR": "För att skapa kontrakt krävs leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_ADRESS": "Adress",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_BETALSATT": "Betalsätt",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_BETALSATT_BANKGIRO": "Bankgiro",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_BETALSATT_BANKKONTO": "Bankkonto",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_BETALSATT_PLUSGIRO": "Plusgiro",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_KONTAKTUPPGIFTER": "Kontaktuppgifter",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_LEVERANTOR": "Leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_PERSONORGNR": "Person/orgnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_ADRESS": "Adress",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_LEVERANTOR": "Leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_PERSON_ORGANISATION": "Person/Orgnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_LEVERANTORSNUMMER": "Leverantörsnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_TELEFON": "Telefon",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_EPOST": "E-post",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_VALJ": "Välj",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_SOKRESULTAT_INFO": "Mer info",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_TA_BORT": "Ta bort",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_KONTAKTPERSON": "Kontaktperson",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_LEVERANTORSNUMMER": "Leverantörsnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_TELEFONNUMMER": "Telefon",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_EPOST": "E-post",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_BETALNINGSMETOD": "Betalningsmetod",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAILS_TABLE_ANDEL": "Andel",
    "VIRKESKOP_ANBUD_KONTRAKT_HEADER_MINA_HANDELSSORTIMENT": "Mina handelssortiment",
    "VIRKESKOP_ANBUD_KONTRAKT_HEADER_SKAPA": "Skapa anbud & kontrakt",
    "SKOGSVARDFPV_ANBUD_KONTRAKT_HEADER_SKAPA": "Skapa skogsvårdsuppdrag",
    "VIRKESKOP_ANBUD_KONTRAKT_HEADER_SKAPA_NGX": "Skapa anbud & kontrakt (ny)",
    "VIRKESKOP_ANBUD_KONTRAKT_HEADER_SOK": "Sök anbud & kontrakt",
    "SKOGSVARDFPV_HEADER_SOK": "Sök skogsvårdsuppdrag",
    "VIRKESKOP_ANBUD_KONTRAKT_LEVERANSPLAN_FORDELA": "Fördela volym från åtgärder",
    "VIRKESKOP_ANBUD_KONTRAKT_LEVERANSPLAN_FORDELA_EJ_GILTIGA_ATGARDER": "Det finns åtgärder som saknar produktionsdatum och det går därför inte att fördela volymer.",
    "VIRKESKOP_ANBUD_KONTRAKT_LEVERANSPLAN_INGEN_GILTIG_PERIOD": "Det krävs en giltig period på kontraktet för att kunna skapa leveransvirkesplan.",
    "VIRKESKOP_ANBUD_KONTRAKT_LEVERANSPLAN_SAKNAR_HANDELSSORTIMENT": "Du behöver lägga till handelssortiment i förkalkylen för att göra en leveransvirkesplan.",
    "VIRKESKOP_ANBUD_KONTRAKT_ATGARDER": "Åtgärder",
    "VIRKESKOP_ANBUD_KONTRAKT_LAGG_TILL_ATGARD": "Lägg till åtgärd",
    "VIRKESKOP_ANBUD_KONTRAKT_LAGG_TILL_FLER_ATGARDER": "Lägg till fler åtgärder",
    "VIRKESKOP_ANBUD_KONTRAKT_LAGG_TILL_KONTRAKT": "Lägg till nytt anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_SKICKA_TILL_VACS": "Skicka till VACS",
    "VIRKESKOP_ANBUD_KONTRAKT_UPPDATERA_VACS": "Uppdatera VACS",
    "VIRKESKOP_ANBUD_KONTRAKT_SKICKA_TILL_VACS_FELMEDDELANDE": "Det gick inte att skicka kontraktet till VACS",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_HEADER_PAGAENDE": "Pågående",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_HEADER_SOK_ANBUD_KONTRAKT": "Sök anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LABEL_ANSVARIG_VIRKESKOPARE": "Ansvarig virkesköpare",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LABEL_AVTALSNUMMER": "Avtalsnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LABEL_KONTRAKTBENAMNING": "Kontraktbenämning",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LABEL_KONTRAKTNUMMER": "Kontraktnummer",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LABEL_LEVERANTOR": "Leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LINK_LAGG_TILL": "Lägg till nytt anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LINK_SOK": "Sök anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_LINK_VISA_PAGAENDE": "Visa pågående anbud & kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_AVTALSNR": "Avtalsnr",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_KONTRAKTBENAMNING": "Kontraktbenämning",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_KONTRAKTDATUM": "Kontraktdatum",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_KONTRAKTNR": "Kontraktnr",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_KONTRAKTSTATUS": "Kontraktstatus",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_LEVERANTOR": "Leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_GILTIGHETSTID": "Giltighetstid",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_GILTIGHETSTID_INTE_GILTIGT": "Inte giltigt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_GILTIGHETSTID_KVAR": "{{ giltighetstid }} kvar",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_KONTRAKTTYP": "Kontrakttyp",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_SENAST_ANDRAD": "Senast ändrad",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_TABLE_MAKULERA": "Makulera",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_MAKULERA_TITLE": "Makulera kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_MAKULERA_BODY": "Kontrollera med VACS-administratör om kontraktet är överfört till VACS.<br/> Observera att kontraktets eventuella arbetsorder kommer att tas bort.<br/> Är du säker på att makulera kontrakt {{kontraktnummer}}?",
    "VIRKESKOP_ANBUD_KONTRAKT_LIST_MAKULERA_CONFIRM_RESPONSE": "Kontraktet har makulerats",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_LEVERANTORSNR": "Leverantörsnr",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_EPOST": "Epost",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_LANK": "Gå till leverantör",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_TELEFON": "Telefon",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_ADRESS": "Adress",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_BANKKONTO": "Bankkonto",
    "VIRKESKOP_ANBUD_KONTRAKT_DETAIL_LEVERANTOR_INFORMATION_POPUP_TITEL": "Om leverantören",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_ATGARDER": "Åtgärder",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER": "Fastighet",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER_KARTA": "Sök direkt i kartan",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER_FORMULAR": "Sök via formulär",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER_KOMMUN": "Kommun",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORTERA_FASTIGHETSUPPGIFTER_FASTIGHETSBETECKNING": "Fastighetsbeteckning",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORT_FASTIGHETSUPPGIFTER_ACTIVE": "Klicka i kartan för att hämta information om en fastighet",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_IMPORT_COLLECTOR_AREA_SELECTOR_ACTIVE": "Du kan lassomarkera för att lägga till ytor, punkter och linjer i kontraktet",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_MENU_COLLECTOR_LAGG_TILL": "Lägg till i kontrakt",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_MENU_COLLECTOR_FORTSATT_MARKERA": "Fortsätt markera",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_DRAW_SELECTED": "Du ritar nu ytan till åtgärden {{atgardsnamn}}.",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_ATGARDSYTA": "Åtgärdsyta {{atgardsnamn}}",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_FIGURAREAL": "Figurareal",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_FIGURAREAL_VALUE": "{{figurareal}} ha",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_BERAKNAR": "Beräknar...",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_LAGG_TILL_DELYTA": "Lägg till delyta",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_BESKAR": "Beskär",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_REDIGERA": "Redigera",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_TA_BORT": "Ta bort",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_ZOOM": "Zooma",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_ZOOM_TO_KONTRAKT": "Zooma och panorera så att alla kartgeometrier i kontraktet syns",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_MEASURE": "Mät",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_MEASURE_TITLE": "Mät i kartan",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_HAMTA": "Hämta uppgifter",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_CONFIRM_HEADER": "Hämta uppgifter",
    "VIRKESKOP_ANBUD_KONTRAKT_MAP_POPUP_CONFIRM_BODY": "Vill du hämta fastighetsuppgifter? Varje hämtning kostar 14 kronor.",
    "VIRKESKOP_ANBUD_KONTRAKT_METOD": "Metod",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_ACCORDION_HEADER": "Naturvärdesbedömning/Riskbedömning",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_BEDOMNING_UTFORD": "Naturvärdesbedömning utförd på samtliga åtgärder",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_BEDOMNINGHEADER": "Hur gjordes bedömningen?",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_BESIKTNINGFALT": "Besiktning i fält",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_KARTSTUDIER": "Kartstudier på rummet (skogens pärlor)",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_VALKANDLEVERANTOR": "Välkänd leverantör där vi har stor lokalkännedom",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_UNDANTAGKOMPLETTERANDEINFO": "Undantag och kompletterande information",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_BUTTON_ANSWER_NO": "Svara nej på alla",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_INSTRUCTION_1": "Har kontraktet i sin helhet, eller finns det i något delområde, områden större än 0.5 ha som har någon av följande kvaliteter?",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_INTRUCTION_2": "Är svaret ja på någon av ovanstående frågor tillkalla nyckelbiotopsinventerare eller annan sakkunnig för naturvärdesbedömning av skogen.",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_INTRUCTION_3": "Lämnas delområdet som hänsyn behöver inte nyckelbiotopsinventerare tillkallas.",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_PLACEHOLDER_ANTECKNINGAR": "Anteckning krävs här*",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_HOGSTUBBAR": "Mer än 10 högstubbar per hektar",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_KANTZON": "Skogsbäck med gammal kantzon",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_LAGOR": "Mer än 10 lågor per hektar (utan gröna barr)",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_LOVSKOG": "Relativt ovanlig lövskog i landskapet",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_NATURVARDESTRAD": "Mer än 15 naturvärdesträd per hektar",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_OVERSILAD": "Översilad skogsmark",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_RODLISTADE_ARTER": "Objekt med kända fynd av rödlistade arter",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_SIGNALARTER": "Objekt med känd förekomst av mer än två signalarter",
    "VIRKESKOP_ANBUD_KONTRAKT_NATURVARDE_RISK_RADIO_ALT_TRADALDER": "Mer än 15 träd/ha över 150 år i söder och 200 år i norr",
    "VIRKESKOP_ANBUD_KONTRAKT_NYATGARD": "Ny åtgärd",
    "VIRKESKOP_ANBUD_KONTRAKT_TAB_TEXT": "Fler",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_AVVERKNINGSKOSTNAD": "Avverkningskostnad",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_FLYTT": "Flytt",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_FSC": "FSC",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_GRUNDPRIS": "Grundpris",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_HANDELSSORTIMENT": "HS",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KOPESKILLING": "Köpeskilling",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KOSTNADER": "Kostnader",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KR": "kr",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KRPERM3FUB": "kr per m3f",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KRPERMATTSLAG": "kr per måttslag",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_KVANTITET": "Kvant",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_M3FUB": "m3f",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_MATTSLAG": "Måttsl",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_MATTSLAG_FULL": "Måttslag",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_MINA_HANDELSSORTIMENT": "Mina handelssortiment",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_NETTOBERAKNING": "Nettoberäkning",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_OVRIGT": "Övrigt",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_DRIVNING": "Drivning",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_PEFC": "PEFC",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_ROTVARDE": "Rotvärde",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SKORDNING": "Skördning",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SKOTNING": "Skotning",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SNITTNETTO": "Snittnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SORTIMENTSNETTO": "Sortimentsnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SORTIMENTSNITTNETTO": "Sortiment- och snittnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_SUMMA": "Summa",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_TACKNINGBIDRAG": "TB",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_TILLAGG": "Tillägg",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_TILLAGGAVDRAG": "TA",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_TOTAL": "Totalt",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_LAGG_TILL": "Lägg till från Mina Handelssortiment",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_UPPDATERA_LISTAN": "Uppdatera listan",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_VAGARAVLAGG": "Vägar/Avlägg",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_VIRKESKOSTNAD": "Virkeskostnad",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_VIRKESVARDE": "Virkesvärde",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_VISA_PDF": "Visa PDF",
    "VIRKESKOP_ANBUD_KONTRAKT_FORKALKYL_HAMTA_PDF": "Hämta PDF",
    "VIRKESKOP_ANBUD_KONTRAKT_KVANTITET": "Kvantitet",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT": "Utskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_ANTECKNING": "Anteckning",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_SORTIMENTSNETTO": "Sortimentsnetto",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_ATERSTALL": "Återställ",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_BRUTTOVOLYM": "Bruttovolym",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_DRIVNINGSKOSTNADER": "Drivningskostnader, kr/m3f",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_FASTIGHETSBETECKNING": "Fastighetsbeteckning",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_FSC": "FSC",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_GALLRING": "Gallring",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_GODKANNANDE_AKTA_MAKE_MAKA_KRAVS_EJ": "Godkännande äkta make/maka krävs ej",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_I_UTSKRIFT": "I utskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_JUSTERA_KONTRAKTSUTSKRIFT": "Justera kontraktsutskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_KONTRAKTETS_BELOPP": "Kontraktets belopp, kr",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_VISA_KONTRAKTETS_BELOPP": "Visa i utskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_KONTRAKTSGRUPPERING": "Kontraktsgruppering areal, ha",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_KR_PER_INMATT": "kr/inmätt",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_LAN_KOMMUN_DISTRIKT": "Län kommun distrikt (LKD)",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_NETTOVOLYM": "Nettovolym",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_OVERSTANDARE": "Överståndare",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_OVRIG_AVVERKNING": "Övrig avverkning",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_OVRIGT_OVERENSKOMMET_MELLAN_KOPARE_OCH_SALJARE": "Övrigt överenskommet mellan köpare och säljare",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PEFC": "PEFC",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_SORTIMENTSKOD": "Sortimentskod",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_HSINMATNING": "Mäts in som",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRELIMINAR_VOLYM_OCH_BELOPP": "Preliminär volym och belopp",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISLISTA": "Prislista",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL": "Pristabell",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_SKAPA_NY_KONTRAKTSUTSKRIFT": "Skapa ny kontraktsutskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_SLUTAVV_MED_FROTRAD": "Slutavv. med fröträd",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_SLUTAVV_UTAN_FROTRAD": "Slutavv. utan fröträd",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_TA": "T/A",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_TAXERAS_SOM_LANTBRUKSENHET": "Taxeras som lantbruksenhet",
    "VIRKESKOP_ANBUD_KONTRAKT_VACS_KONTRAKT_STATUS": "Status i vacs",
    "VIRKESKOP_ANBUD_KONTRAKT_VACS_KONTRAKT_KONTRAK_AVSLUTAT": "Kontraktet är avslutat i VACS",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_TOTAL_KVANTITET": "Total kvantitet ca, m3f",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_VALJ": "Välj",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_STAMPLINGSLANGD": "Stämplingslängd",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_KOPESKILLING": "Köpeskilling",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_DATUM_UPPRATTAD": "Datum upprättad*",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_UPPRATTAD_AV": "Upprättad av*",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_EXKL_MOMS_KR": "Exkl. moms, kr*",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_ANTAL_TRAD_ST": "Antal träd, st*",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_EXKL_MOMS_KR_UTSKRIVET": "Exkl. moms utskrivet, kr*",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_VISA_LEVERANSVIRKESPLAN": "Visa leveransvirkesplan på utskrift",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL_FILTRERA_MARKNADSPRISLISTOR_TITLE": "Filtrera marknadsprislistor",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL_FILTRERA_MARKNADSPRISLISTOR_VISA_ENDAST_VLG": "Visa endast VLG-marknadsprislistor",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL_FILTRERA_MARKNADSPRISLISTOR_VISA_INAKTUELLA": "Visa inaktuella marknadsprislistor",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL_FILTRERA_MARKNADSPRISLISTOR_VISA_OAVSETT_HSGRUPP": "Visa marknadsprislistor oavsett HS-grupper",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_PRISTABELL_VID_LEVERANS_GALLANDE_KORTNAMN": "VLG",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_KOPIERA_RAD": "Kopiera rad",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_RADERA_RAD": "Ta bort rad",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_CONFIRM_TITLE": "Återställning",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_CONFIRM_MESSAGE": "Vill du verkligen återställa? Alla förändringar du gjort kommer att ersättas med data från förkalkyl och åtgärder.",
    "VIRKESKOP_ANBUD_KONTRAKT_UTSKRIFT_UPPDATERA_PRISTABELL": "Uppdatera pristabell",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_IMPORT_HEADER": "Vilken åtgärd tillhör åtgärdsytan?",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_GA_VIDARE": "Importera",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_TITLE": "Åtgärdsytan kunde inte importeras",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_MESSAGE": "För att importera åtgärdsytor måste det finnas åtgärder att koppla dem till i kontraktet. Skapa åtgärden och försök igen.<br><br>Hur vill du fortsätta?",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_IMPORT": "Importera övriga geometrier",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_CANCEL": "Avbryt importen",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_END_TITLE": "Vill du avsluta importen?",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_END_MESSAGE": "Den markerade informationen har nu lagts till i kontraktet. Field Maps-lagret kommer att släckas.",
    "VIRKESKOP_ANBUD_KONTRAKT_COLLECTOR_DIALOG_END_CANCEL": "Nej, fortsätt importera",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGD_ANSVARIGVK": "Du har lagts till som ansvarig virkesköpare för {{ leverantor }}",
    "VIRKESKOP_ANBUD_KONTRAKT_TILLAGD_INTRESSENT": "Du har lagts till som intressent till {{ leverantor }}",
    "VIRKESKOP_HANDELSSORTIMENT_HEADER_MINA_HANDELSSORTIMENT": "Mina handelssortiment",
    "VIRKESKOP_HANDELSSORTIMENT_HEADER_SOK": "Sök handelssortiment",
    "VIRKESKOP_HANDELSSORTIMENT_LABEL_AKTIV": "Aktiv",
    "VIRKESKOP_HANDELSSORTIMENT_LABEL_HANDELSSORTIMENT": "Handelssortiment",
    "VIRKESKOP_HANDELSSORTIMENT_LABEL_HANDELSSORTIMENTGRUPP": "Handelssortimentsgrupp",
    "VIRKESKOP_HANDELSSORTIMENT_LABEL_PRODUKT": "Produkt",
    "VIRKESKOP_HANDELSSORTIMENT_SNITTNETTO_SAMTLIGA": "Samtliga/övriga",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_AKTIV": "Aktiv",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_FINNS_REDAN": "Du har redan detta handelssortiment i din lista.",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_GILTIGHET": "Giltighet",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_HANDELSSORTIMENT": "Handelssortiment",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_PRODUKTER": "Produkter",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_MINA_TA_BORT": "Ta bort",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_AKTIV": "Aktiv",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_GILTIGHET": "Giltighet",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_HANDELSSORTIMENT": "Handelssortiment",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_LAGG_TILL": "Lägg till",
    "VIRKESKOP_HANDELSSORTIMENT_TABLE_SOK_PRODUKTER": "Produkter",
    "VIRKESKOP_ATGARD_HAMTA_VOLYM_FRAN_FORKALKYL": "Hämta volym från förkalkyl",
    "VIRKESKOP_ATGARD_INGA_VOLYMER": "Inga volymer hittades",
    "VIRKESKOP_HEADER": "Virkesköp",
    "SKOGSVARDFPV_HEADER": "Skogsvård",
    "KARTA_HEADER": "Karta",
    "VIRKESKOP_HIDE_FORM": "Dölj formulär",
    "VIRKESKOP_HIDE_MAP": "Dölj karta",
    "VIRKESKOP_SHOW_FORM": "Visa formulär",
    "VIRKESKOP_SHOW_MAP": "Visa kartan",
    "VIRKESKOP_VALIDERING_SKOGSAGAREVIRKESLEVERANTOR": "Ange minst en leverantör eller en anbudsleverantör.",
    "VIRKESKOP_VALIDERING_VIRKESLEVERANTOR_KONTRAKT": "Ange minst en leverantör för att kunna skapa kontrakt.",
    "VIRKESKOP_VALIDERING_SKOGSAGARE_KONTRAKT": "Anbudsleverantören behöver registreras i Lime för att kunna skapa kontrakt.",
    "VIRKESKOP_VALIDERING_VIRKESLEVERANTOR_ANBUD": "Ange minst en leverantör för att kunna skapa anbud.",
    "VIRKESKOP_VALIDERING_SKOGSAGARE_KONTRAKT_PERSONORGNUMMER": "Person-/Organisationsnumret har fel format. 10 eller 12 siffror. (nnnnnnnn-nnnn)",
    "VIRKESKOP_VALIDERING_ANSVARIG_VIRKESLEVERANTOR": "Ansvarig virkesköpare saknas.",
    "VIRKESKOP_VALIDERING_AFFARSFORM_SAKNAS": "Affärsform saknas.",
    "VIRKESKOP_VALIDERING_NETTOTYP_SAKNAS": "Ange sortimentsnetto eller snittnetto för att skapa ett leveransrotköp.",
    "VIRKESKOP_VALIDERING_KONTRAKT_GILTIGHETSTID_FROM": "Ange giltighetstid fr om för att kunna skapa kontrakt.",
    "VIRKESKOP_VALIDERING_KONTRAKT_GILTIGHETSTID_TOM": "Ange giltighetstid t o m för att kunna skapa kontrakt.",
    "VIRKESKOP_VALIDERING_KONTRAKT_GILTIGHETSTID_TOM_INNAN_FROM": "Ange datum för Gilighetstid t o m som infaller efter Giltighetstid fr o m",
    "VIRKESKOP_VALIDERING_ANBUD_ATGARD_TILLGANGLIGT": "Kontraktstatus kan inte vara anbud om det finns tillgängliga åtgärder. Ändra planeringsstatus på ingående åtgärder.",
    "VIRKESKOP_VALIDERING_ATGARD_PRODUKTIONSOMRADE": "Produktionsområde har inte kunnat fastställas och måttslagskonverteringen blir då inkorrekt. Rita åtgärdsgeometrier i kartan så att produktionsområdet kan räknas ut.",
    "VIRKESKOP_VALIDERING_STATUS_BORTTAG_ARBETSORDER_ATGARD": "Observera att kontraktets eventuella arbetsorder kommer att tas bort.",
    "VIRKESKOP_VALIDERING_STATUS_KONTROLLERA_VACS": "Kontrollera med VACS-administratör om kontraktet är överfört till VACS.",
    "VIRKESKOP_VALIDERING_VIRKESKOPARE_AGARANDEL": "Ange ägarandel för alla leverantörer.",
    "VIRKESKOP_VALIDERING_FASTIGHETSBETECKNING": "Ange fastighetsbeteckning.",
    "VIRKESKOP_VALIDERING_SORTIMENTNETTOPRISLISTA": "Ange pris för varje handelssortiment.",
    "VIRKESKOP_VALIDERING_INMATNINGSHANDELSSORTIMENT": "Alla rader måste ha inmätningshandelssortiment.",
    "VIRKESKOP_VALIDERING_KOPESKILLINGEXKLMOMSU2": "Ange köpeskilling exkl moms.",
    "VIRKESKOP_VALIDERING_DRIVNINGSKOSTNADERU4": "Ange drivningskostnad per m3f.",
    "VIRKESKOP_VALIDERING_TOTALKVANTITETU4U5": "Ange total kvantitet per m3f.",
    "VIRKESKOP_VALIDERING_KONTRAKTETSBELOPPU4U5": "Ange kontraktets belopp.",
    "VIRKESKOP_VALIDERING_HANDELSSORTIMENTKVANTITET": "Handelssortiment saknar kvantitet. Ange kvantitet för samtliga handelssortiment.",
    "VIRKESKOP_VALIDERING_CERTIFIKATKONTROLLDATUM": "Datum för giltighetskontroll saknas för certifikatstyp.",
    "VIRKESKOP_VALIDERING_CERTIFIKATKONTROLLNR": "Nummer och namn saknas för certifikatstyp.",
    "VIRKESKOP_VALIDERING_VIRKESLEVERANTOR_AGARANDEL_100": "Ägarfördelningen är ofullständig.",
    "VIRKESKOP_VALIDERING_LEVERANTOR_BETALNINGSMETOD_ADRESS": "Ange fullständig adress på samtliga leverantörer med avi som betalningmetod.",
    "VIRKESKOP_VALIDERING_LEVERANTOR_BETALNINGSMETOD_PLUSGIRO": "Ange plusgironummer på samtliga leverantörer med plusgiro som betalningmetod.",
    "VIRKESKOP_VALIDERING_LEVERANTOR_BETALNINGSMETOD_BANKGIRO": "Ange bankgironummer på samtliga leverantörer med bankgiro som betalningmetod.",
    "VIRKESKOP_VALIDERING_LEVERANTOR_BETALNINGSMETOD_BANKKONTO": "Ange fullständiga bankkontouppgifter på samtliga leverantörer med bankkonto som betalningmetod.",
    "VIRKESKOP_VALIDERING_KONTRAKTBELOPP_SAKNAS": "Kontraktbelopp saknas.",
    "VIRKESKOP_VALIDERING_BELOPP_STORRE_AN_KONTRAKTBELOPP": "Summa betalningar i betalplan får inte överstiga kontraktets belopp.",
    "VIRKESKOP_VALIDERING_BELOPP_STORRE_AN_75_PROCENT": "Summa betalningar i betalplan överstiger en rekommenderad gräns på 75% av kontraktets belopp",
    "VIRKESKOP_VALIDERING_BELOPP_STORRE_AN_0": "Belopp måste vara större än 0",
    "VIRKESKOP_VALIDERING_BETALDATUM_TIDIGARE_AN_DAGENS_DATUM": "Betaldatum är tidigare än dagens datum",
    "VIRKESKOP_VALIDERING_ATGARDSTATUS_FROM_TILLGANGLIG_ON_AO_PAGAR": "Status kan inte ändras från Tillgänglig då arbetsordern har produktionstatus pågår",
    "VIRKESKOP_VALIDERING_DRIVNINGSPUNKTER_ATGARDSTATUS_TILLGANGLIG": "Obligatoriska drivningspunkter måste finnas innan planeringsstatus får sättas till Tillgängligt",
    "VIRKESKOP_VALIDERING_NETTOAREAL": "Ange nettoareal.",
    "VIRKESKOP_VALIDERING_MEDELSTAM": "Ange medelstam.",
    "VIRKESKOP_VALIDERING_TILLGANGLIGHET_SKOG": "Ange tillgänglighet skog.",
    "VIRKESKOP_VALIDERING_TILLGANGLIGHET_VAG": "Ange tillgänglighet väg.",
    "VIRKESKOP_VALIDERING_TILLGANGLIGHET_SKOTNINGSAVSTAND": "Ange skotningsavstånd.",
    "VIRKESKOP_VALIDERING_NATURVARDERISKBEDOMNING": "Slutför naturvärdesbedömningen för att kunna ge åtgärden status tillgänglig.",
    "VIRKESKOP_VALIDERING_ATGARDSGEOMETRI": "Rita åtgärdens åtgärdsyta i kartan för att kunna ge åtgärden status tillgänglig.",
    "VIRKESKOP_VALIDERING_VIRKESKOSTNAD_KVANTITET": "Ange kvantitet för minst ett handelssortiment i förkalkylen.",
    "VIRKESKOP_VALIDERING_VIRKESKOSTNAD_CERTIFIKAT": "Du kan inte ange ett certifieringstillägg för {{certifikatTyp}} utan att ha kopplat certifikat till kontraktet. Komplettera med certifikat av rätt typ.",
    "VIRKESKOP_VALIDERING_PRISRAD_SORTIMENT": "Minst en pristabellsrad för handelssortiment saknar sortiment. Ange sortiment för att kunna skicka till VACS.",
    "VIRKESKOP_VALIDERING_KARTGEOMETRI_SUBTYP_SAKNAS": "Subtyp av kartgeometri måste anges",
    "VIRKESKOP_VALIDERING_KARTGEOMETRI_TYP_SAKNAS": "Typ av kartgeometri måste anges",
    "VIRKESKOP_VALIDERING_PRISRAD_DISTINCT": "I pristabellen förekommer det rader med olika prisuppgifter för samma sortimentskod och måttslag. Ändra prisuppgifter för att kunna skriva ut kontraktet/skicka till VACS",
    "VIRKESKOP_VALIDERING_PRISRAD_DISTINCT_VIOL3": "I pristabellen förekommer det rader med olika prisuppgifter för samma inmätningshandelssortiment och måttslag. Ändra prisuppgifter för att kunna skriva ut kontraktet/skicka till VACS",
    "VIRKESKOP_VALIDERING_KONTRAKTBENAMNING": "Benämning kontrakt är obligatoriskt",
    "VIRKESKOP_VALIDERING_KONTRAKTBENAMNING_LANGD": "Benämning kontrakt får inte överstiga {{maxtecken}} tecken",
    "VIRKESKOP_VALIDERING_KONTRAKT_ALLA_ATGARDER_NETTOAREA": "Den sammanlagda ytan av åtgärd {{atgardsbeteckningar}} överstiger 0,5 ha. Om de ska avverkas samtidigt krävs avverkningsanmälan på samtliga åtgärder. Överväg avverkningsanmälan till skogsstyrelsen",
    "VIRKESKOP_VALIDERING_LEVERANTOR_NAMN": "Du måste ange ett namn på leverantören",
    "VIRKESKOP_VALIDERING_ANBUDBENAMNING_LANGD": "Benämning avtal får inte överstiga {{maxtecken}} tecken",
    "VIRKESKOP_VARDEBEVAKNING_DOLJ": "Dölj",
    "VIRKESKOP_VARDEBEVAKNING_VISA": "Värdeberäkning",
    "VIRKESORDER_TERMINAL_HEADER": "Terminal",
    "VIRKESORDER_NUMBER": "Nummer",
    "VIRKESORDER_NOT_FOUND": "Hittade ingen virkesorder",
    "VIRKESORDER_TERMINAL_SOK": "Sök terminalvirkesorder",
    "VIRKESORDER_TYPE_AHEAD_HELP_TEXT": "Sök handelssortiment",
    "VIRKESORDER_ADD_HANDELSSORTIMENT": "Lägg till handelssortiment",
    "VIRKESORDER_ADD_TRANSPORTFORETAG": "Transportilldelning",
    "VIRKESORDER_ADDED_HANDELSSORTIMENT": "Upplagda handelssortiment",
    "VIRKESORDER_ADDED_HANDELSSORTIMENT_INFO": "✓ Betyder att virkesorderns handelssortimentet har sortiment som finns i virkesorderns SSTE",
    "KARTGEOMETRI_POPUP_KARTGEOMETRI_TYP": "Typ",
    "KARTGEOMETRI_POPUP_OVERFART_TYP": "Typ av överfart",
    "KARTGEOMETRI_POPUP_OVRIG_DRIVNINGSPUNKT_TYP": "Typ övrig drivningspunkt",
    "KARTGEOMETRI_POPUP_HANSYN_YTA_TYP": "Typ hänsyn yta",
    "KARTGEOMETRI_POPUP_HANSYN_PUNKT_TYP": "Typ hänsyn punkt",
    "KARTGEOMETRI_POPUP_HANSYN_LINJE_TYP": "Typ hänsyn linje",
    "KARTGEOMETRI_POPUP_TILLGANGLIGHETSKLASS": "Tillgänglighetsklass",
    "KARTGEOMETRI_POPUP_ANTECKNING": "Anteckning",
    "KARTGEOMETRI_POPUP_LANGD": "Längd, m",
    "KARTGEOMETRI_POPUP_AREAL": "{{figurAreal}} ha",
    "KARTGEOMETRI_POPUP_RUBRIK": "{{subtyp1}}",
    "KARTGEOMETRI_POPUP_KARTGEOMETRI_AREAL": "Figurareal",
    "KARTGEOMETRI_POPUP_LAGG_TILL_DELYTA": "Lägg till delyta",
    "KARTGEOMETRI_POPUP_BESKAR": "Beskär",
    "KARTGEOMETRI_POPUP_PLOCKHUGGNING": "Plockhuggning",
    "KARTGEOMETRI_MAP_DRAW_DRIVNINGSLINJER": "Drivningslinjer",
    "KARTGEOMETRI_MAP_DRAW_DRIVNINGSPUNKTER": "Drivningspunkter",
    "KARTGEOMETRI_MAP_DRAW_HANSYN_LINJER": "Hänsyn linjer",
    "KARTGEOMETRI_MAP_DRAW_HANSYN_PUNKTER": "Hänsyn punkter",
    "KARTGEOMETRI_MAP_DRAW_HANSYN_YTOR": "Hänsyn ytor",
    "KARTGEOMETRI_MAP_DRAW_NEW_DRIVNINGSLINJE": "Ny drivningslinje",
    "KARTGEOMETRI_MAP_DRAW_NEW_DRIVNINGSPUNKT": "Ny drivningspunkt",
    "KARTGEOMETRI_MAP_DRAW_NEW_VAG": "Ny väg",
    "KARTGEOMETRI_MAP_DRAW_NEW_HANSYN_YTA": "Ny hänsyn yta",
    "KARTGEOMETRI_MAP_DRAW_NEW_HANSYN_PUNKT": "Ny hänsyn punkt",
    "KARTGEOMETRI_MAP_DRAW_NEW_HANSYN_LINJE": "Ny hänsyn linje",
    "KARTGEOMETRI_MAP_DRAW_SELECTED": "Du ritar nu kartgeometri {{subtyp1}}.",
    "KARTGEOMETRI_MAP_DRAW_VAGAR": "Vägar",
    "LEVERANTOR_LEVERANTOREN_SPARAD": "Leverantören sparad",
    "LEVERANTOR_ANBUDSLEVERANTOREN_SPARAD": "Anbudsleverantören sparad",
    "LEVERANTOR_KONTAKT_SKAPAD": "Kontakt skapad",
    "LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT": "Ange minst tre tecken",
    "LEVERANTOR_HEADER": "Leverantörer",
    "LEVERANTOR_HEADER_ADM_INFO": "Administrativ information",
    "LEVERANTOR_HEADER_EKONOMI": "Ekonomi",
    "LEVERANTOR_HEADER_HISTORIK": "Historik",
    "LEVERANTOR_HEADER_KONTAKT": "Kontakt",
    "LEVERANTOR_HEADER_KONTAKTUPPGIFTER": "Leverantör",
    "LEVERANTOR_HEADER_LEVERANTOR": "Leverantör",
    "LEVERANTOR_HEADER_ANBUDSLEVERANTOR": "Anbudsleverantör",
    "LEVERANTOR_HEADER_KUNDVARD": "Kundvård",
    "LEVERANTOR_HEADER_LEVVARD": "Leverantörsvård",
    "LEVERANTOR_LABEL_ADRESS": "Adress 1",
    "LEVERANTOR_LABEL_ADRESS2": "Adress 2",
    "LEVERANTOR_LABEL_AFFARSFORM": "Affärsform",
    "LEVERANTOR_LABEL_AKTIVITET": "Aktivitet",
    "LEVERANTOR_LABEL_AKTIVITETER": "Aktiviteter",
    "LEVERANTOR_LABEL_ANSLUTNINGSDATUM": "Anslutningsdatum",
    "LEVERANTOR_LABEL_ANSV_VIRKESKOPARE": "Ansvarig virkesköpare för leverantören",
    "LEVERANTOR_LABEL_ANTECKNINGAR": "Anteckningar",
    "LEVERANTOR_LABEL_ANVANDARID": "Användare-ID",
    "LEVERANTOR_LABEL_BETALNINGSMETOD": "Betalningsmetod",
    "LEVERANTOR_LABEL_BANKGIRO": "Bankgiro",
    "LEVERANTOR_LABEL_PLUSGIRO": "Plusgiro",
    "LEVERANTOR_LABEL_BANKKONTO": "Bankkonto",
    "LEVERANTOR_LABEL_CLEARING": "Clearing",
    "LEVERANTOR_LABEL_BIC_SWIFT": "BIC/Swift",
    "LEVERANTOR_LABEL_IBAN": "IBAN",
    "LEVERANTOR_LABEL_GLN": "GLN",
    "LEVERANTOR_LABEL_CERTIFIERING": "Certifiering",
    "LEVERANTOR_LABEL_CERTIFIERING_UTFARDAT_AV": "Certifiering utfärdat av",
    "LEVERANTOR_LABEL_CERTIFIKAT": "Certifikat",
    "LEVERANTOR_LABEL_DATUM": "Datum",
    "LEVERANTOR_LABEL_SENASTE_UPPDATERINGEN_FRAN_LIME": "Senaste uppdateringen från Lime",
    "LEVERANTOR_LABEL_HAR_EJ_REDIGERA_ROLL": "Roll saknas för att kunna redigera virkesleverantör",
    "LEVERANTOR_LABEL_EJ_SKICKAD_TILL_LIME": "Ej skickad till Lime",
    "LEVERANTOR_LABEL_EFTERNAMN": "Efternamn",
    "LEVERANTOR_LABEL_EPOST": "E-post",
    "LEVERANTOR_LABEL_FORNAMN": "Förnamn",
    "LEVERANTOR_LABEL_GRUPP": "Grupp",
    "LEVERANTOR_LABEL_GRUPPERING": "Gruppering",
    "LEVERANTOR_LABEL_HUVUDKONTOR": "Huvudkontor",
    "LEVERANTOR_LABEL_INTRESSENT_FINNS_REDAN": "Intressent redan tillagd",
    "LEVERANTOR_LABEL_INTRESSENTER": "Intressenter",
    "LEVERANTOR_LABEL_KLASSNING": "Klassning",
    "LEVERANTOR_LABEL_KONTAKTPERSON": "Kontaktperson",
    "LEVERANTOR_LABEL_KONTOR": "Kontor",
    "LEVERANTOR_LABEL_KONTRAKT": "Kontrakt",
    "LEVERANTOR_LABEL_KONTRAKTS_NAMN": "Kontraktsnamn",
    "LEVERANTOR_LABEL_KONTROLLANT": "Kontrollant",
    "LEVERANTOR_LABEL_KONTROLLDATUM": "Kontrolldatum",
    "LEVERANTOR_LABEL_LAND": "Land",
    "LEVERANTOR_LABEL_LAGG_TILL_MIG": "Lägg till mig",
    "LEVERANTOR_LABEL_LEVERANTORS_KATEGORI": "Leverantörskategori",
    "LEVERANTOR_LABEL_LIMEID": "Leverantörsnr",
    "LEVERANTOR_LABEL_M3FUB": "m3f",
    "LEVERANTOR_LABEL_MOBIL": "Mobilnummer",
    "LEVERANTOR_LABEL_MOMS_REGNR": "Momsregistreringsnr",
    "LEVERANTOR_LABEL_MOMS_KOD": "Momskod",
    "LEVERANTOR_LABEL_NAMN": "Leverantör",
    "LEVERANTOR_LABEL_ORGNR": "Person/Orgnr",
    "LEVERANTOR_LABEL_POSTNR": "Postnummer",
    "LEVERANTOR_LABEL_POSTORT": "Postort",
    "LEVERANTOR_LABEL_SKAPA_I_LIME": "Skapa leverantör i Lime",
    "LEVERANTOR_LABEL_SKAPA_ANBUDSLEVERANTOR": "Skapa anbudsleverantör",
    "LEVERANTOR_LABEL_SKAPA_LEVERANTOR": "Skapa leverantör",
    "LEVERANTOR_LABEL_STATUS": "Status",
    "LEVERANTOR_LABEL_TELEFON": "Telefonnummer",
    "LEVERANTOR_LABEL_TYP": "Typ",
    "LEVERANTOR_LABEL_UTBO_ABO": "Utbo/Åbo",
    "LEVERANTOR_LABEL_BOENDE_FASTIGHET": "Boende/fastighet",
    "LEVERANTOR_LABEL_UTFARDARE": "Utfärdare",
    "LEVERANTOR_LABEL_UTSKICK": "Utskick",
    "LEVERANTOR_LABEL_KONTAKTTYP": "Typ av kontakt",
    "LEVERANTOR_LABEL_SKYDDADIDENTITET": "Skyddad identitet",
    "LEVERANTOR_LABEL_GILTIGTSVENSKTORGNR": "Giltigt svenskt Person/Orgnr",
    "LEVERANTOR_LABEL_VILLHAALMANACKAN": "Vill ha almanackan",
    "LEVERANTOR_LABEL_VILLHAFORUM": "Vill ha Forum",
    "LEVERANTOR_LABEL_AVSTARFORUM": "Avstår Forum",
    "LEVERANTOR_LIST_ORDERSOK_PLACEHOLDER": "Sök på namn, ort, person/organisationsnummer",
    "LEVERANTOR_LIST_SOK": "Sök Anbudsleverantör/leverantör",
    "LEVERANTOR_VALIDERING_KONTAKTNAMN": "Leverantör är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTPERSONFORNAMN": "Förnamn är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTPERSONEFTERNAMN": "Efternamn är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTORGNR": "Person-/organisationsnummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTORGNRFORMAT": "Organisationsnumret har fel format. Det måste vara 10 siffror. (nnnnnn-nnnn)",
    "LEVERANTOR_VALIDERING_KONTAKTPNRFORMAT": "Personnumret har fel format. Det måste vara 12 siffror. (YYYYMMDD-XXXX)",
    "LEVERANTOR_VALIDERING_TYPAVKONTAKT": "Typ av kontakt är obligatoriskt",
    "LEVERANTOR_VALIDERING_ADRESS": "Adress saknas",
    "LEVERANTOR_VALIDERING_KONTAKTPOSTNR": "Postnummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTORT": "Postort är obligatoriskt",
    "LEVERANTOR_VALIDERING_KONTAKTLAND": "Land är obligatoriskt",
    "LEVERANTOR_VALIDERING_MOMSREGISTRERINGSNUMMER": "Momsregistreringsnummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_BETALNINGSMETOD": "Betalningsmetod obligatoriskt",
    "LEVERANTOR_VALIDERING_PLUSGIRO": "Plusgironummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_BANKGIRO": "Bankgironummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_BANKKONTO": "Bankkontonummer är obligatoriskt",
    "LEVERANTOR_VALIDERING_CLEARINGNUMMER": "Clearingnummer är obligatoriskt",
    "MARKNADSPRISLISTA_HEADER": "Marknadsprislista",
    "FORDELNINGSTYP_BUTTON_GENERERA_FRAN_LANGD": "Generera från längdmoduler",
    "FORDELNINGSTYP_FORBJUDEN": "Förbjuden",
    "FORDELNINGSTYP_MANUELL": "Manuella kap",
    "FORDELNINGSTYP_MAX": "Max",
    "FORDELNINGSTYP_MIN": "Min",
    "FORDELNINGSTYP_MIX": "Mix",
    "FORDELNINGSTYP_RENSA": "Rensa",
    "FORSALJNING_HEADER": "Försäljning",
    "GRID_applyFilter": "Applicera filter",
    "GRID_blanks": "Blank",
    "GRID_columns": "Kolumner",
    "GRID_contains": "Innehåller",
    "GRID_endsWith": "Slutar med",
    "GRID_equals": "Lika med",
    "GRID_filterOoo": "Filter...",
    "GRID_first": "Första",
    "GRID_greaterThan": "Större än",
    "GRID_group": "Grupp",
    "GRID_last": "Sista",
    "GRID_lessThan": "Mindre än",
    "GRID_loadingOoo": "Laddar...",
    "GRID_more": "Mer",
    "GRID_next": "Nästa",
    "GRID_notEquals": "Inte lika med",
    "GRID_notEqual": "Inte lika med",
    "GRID_notContains": "Inte innehåller",
    "GRID_of": "Av",
    "GRID_page": "Sida",
    "GRID_pivotedColumns": "Pivotkolumner",
    "GRID_pivotedColumnsEmptyMessage": "Dra kolumner hit",
    "GRID_previous": "Föregående",
    "GRID_searchOoo": "Sök",
    "GRID_selectAll": "Välj alla",
    "GRID_startsWith": "Börjar med",
    "GRID_to": "Till",
    "GRID_valueColumns": "Värdekolumner",
    "GRID_valueColumnsEmptyMessage": "Dra kolumner hit",
    "GRID_andCondition": "och",
    "GRID_orCondition": "eller",
    "GRID_noRowsToShow": "Finns inga rader att visa...",
    "HANDELSELOGG_COLUMN_FIELD": "Fält",
    "HANDELSELOGG_COLUMN_NEW_VALUE": "Nytt värde",
    "HANDELSELOGG_COLUMN_OLD_VALUE": "Gammalt värde",
    "HANDELSELOGG_COLUMN_TABEL": "Tabell",
    "HANDELSELOGG_FILTER_TEXT": "Filtrera",
    "HANDELSELOGG_HEADER": "Händelselogg",
    "HANDELSSORTIMENT_DETAIL_AKTIV": "Aktiv",
    "HANDELSSORTIMENT_DETAIL_BESKRIVNING": "Beskrivning",
    "HANDELSSORTIMENT_DETAIL_BETECKNING": "Beteckning",
    "HANDELSSORTIMENT_DETAIL_HUVUDSORTIMENT": "Huvudsortiment",
    "HANDELSSORTIMENT_DETAIL_DELETE_PRODUKT_PROMPT_HEADER": "Radera produkt",
    "HANDELSSORTIMENT_DETAIL_DELETE_PRODUKT_PROMPT_TEXT": "Vill du verkligen ta bort produkten?",
    "HANDELSSORTIMENT_DETAIL_DELETE_PROMPT_HEADER": "Radera handelssortiment",
    "HANDELSSORTIMENT_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av handelssortiment",
    "HANDELSSORTIMENT_DETAIL_EDITERA": "Handelssortiment",
    "HANDELSSORTIMENT_DETAIL_ERROR_ANDEL_VALUE": "Värdet får inte överstiga 100%",
    "HANDELSSORTIMENT_DETAIL_ERROR_FROM": "Fr.o.m. saknas",
    "HANDELSSORTIMENT_DETAIL_ERROR_TO": "T.o.m. saknas",
    "HANDELSSORTIMENT_DETAIL_FROM": "Giltig fr.o.m.",
    "HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_ANDEL_LABEL": "Andel (%)",
    "HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_FORDELNINGSTYP_LABEL": "Fördelningstyp",
    "HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_PRODUKT_LABEL": "Produkt",
    "HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_TA_BORT_LABEL": "Ta bort",
    "HANDELSSORTIMENT_DETAIL_LAGERENHET": "Lagerenhet",
    "HANDELSSORTIMENT_DETAIL_NAMN": "Namn",
    "HANDELSSORTIMENT_DETAIL_PRODUKT_HEADER": "Lägg till Produkter",
    "HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "HANDELSSORTIMENT_DETAIL_SAMTLIGA_SORTIMENTSKODER": "Samtliga sortimentskoder",
    "HANDELSSORTIMENT_DETAIL_SKAPA_NY": "Skapa nytt handelssortiment",
    "HANDELSSORTIMENT_DETAIL_SKAPAD_AV": "Skapad av",
    "HANDELSSORTIMENT_DETAIL_TOM": "Giltig t.o.m.",
    "HANDELSSORTIMENT_DETAIL_VALDA_SORTIMENTSKODER": "Valda sortimentskoder",
    "HANDELSSORTIMENT_DETAIL_VIOLID": "ViolId",
    "HANDELSSORTIMENT_DETAIL_RELATERADE_HANDELSSORTIMENT_LABEL": "Relaterade handelssortiment",
    "HANDELSSORTIMENT_DETAIL_RELATERADE_HANDELSSORTIMENT_LABEL_TOOLTIP": "Följande handelssortiment räknas in i plan och utfall för aktuellt handelssortiment",
    "HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL": "Relatera till handelssortiment",
    "HANDELSSORTIMENT_DETAIL_RELATERA_TILL_HANDELSSORTIMENT_LABEL_TOOLTIP": "Aktuellt handelssortimentet räknas in i plan och utfall för valt handelssortiment",
    "HANDELSSORTIMENT_DETAIL_RAVARA_HANDELSSORTIMENT_LABEL": "Ange råvarans handelssortiment",
    "HANDELSSORTIMENT_DETAIL_RAVARA_FRAN_LABEL": "Råvara från",
    "HANDELSSORTIMENT_DETAIL_RAVARA_FORADLADFORM_LABEL": "Förädlad form",
    "HANDELSSORTIMENT_DETAIL_RAVARA_HANDELSSORTIMENT_LABEL_TOOLTIP": "Används om valt handelssortiment är förädlad form av ett annat handelssortiment",
    "HANDELSSORTIMENT_DETAIL_FORESLAGET_MATTSLAG": "Föreslaget måttslag",
    "HANDELSSORTIMENT_HEADER": "Handelssortiment",
    "HANDELSSORTIMENT_LIST_AKTIV": "Aktiv",
    "HANDELSSORTIMENT_LIST_FORPRODUKTION": "Produktion",
    "HANDELSSORTIMENT_LIST_FORINMATNING": "Inmätning",
    "HANDELSSORTIMENT_LIST_BETECKNING": "Beteckning",
    "HANDELSSORTIMENT_LIST_NAMN": "Namn",
    "HANDELSSORTIMENT_LIST_NYTT": "nytt",
    "HANDELSSORTIMENT_LIST_PRODUKT": "Produkt",
    "HANDELSSORTIMENT_LIST_PRODUKTER": "Produkter",
    "HANDELSSORTIMENT_LIST_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "HANDELSSORTIMENT_LIST_SOK": "Sök handelssortiment",
    "HANDELSSORTIMENT_LIST_SORTIMENTKOD": "Sortimentskod",
    "HANDELSSORTIMENT_LIST_VIOLID": "Violid",
    "HANDELSSORTIMENT_LIST_STATUS": "Status",
    "HANDELSSORTIMENT_PRODUKT_NY_PRODUKT": "Lägg till",
    "HANDELSSORTIMENTSGRUPP_TALLTIMMER": "Talltimmer",
    "HANDELSSORTIMENTSGRUPP_GRANTIMMER": "Grantimmer",
    "HANDELSSORTIMENTSGRUPP_KLENTIMMER": "Klentimmer barr",
    "HANDELSSORTIMENTSGRUPP_LOVTIMMER": "Lövtimmer",
    "HANDELSSORTIMENTSGRUPP_OVRIGTBARRTIMMER": "Övrigt barrtimmer",
    "HANDELSSORTIMENTSGRUPP_BARRMASSAVED": "Barrmassaved",
    "HANDELSSORTIMENTSGRUPP_ENERGIVED": "Energived",
    "INMATNING_INFO_BEGRANSNING_SOK": "Datumintervall längre än 4 månader är inte möjligt utan andra begränsande filter",
    "INMATNING_INMATNINGSDATUM_FROM": "Inmätningsdatum fr.o.m.",
    "INMATNING_INMATNINGSDATUM_TOM": "Inmätningsdatum t.o.m.",
    "INMATNING_KOPPLAD_KUND": "Kopplad kund",
    "INMATNING_KOPPLAT_HANDELSSORTIMENT": "Kopplat handelssortiment",
    "INMATNING_LABEL_KUND": "Kund (Hkod-intern nr.)",
    "INMATNING_LABEL_LEVERANTOR": "Leverantör (Hkod-intern nr.)",
    "INMATNING_LABEL_TRANSPORTFORETAG": "Transportföretag (Hkod-intern nr.)",
    "INMATNING_LABEL_TRANSPORTORSKOD": "Transportörskod",
    "INMATNING_MATTSLAG": "Måttslag",
    "INMATNING_MOTTAGNINGSPLATS": "Mottagningsplats",
    "INMATNING_RADATA_HEADER": "Rådata från mätning",
    "INMATNING_SOK_KUNDNAMN": "Sök på kundnamn",
    "INMATNING_SORTIMENTKOD": "Sortimentkod",
    "INMATNING_VIEW_HEADER": "Sök inmätningar",
    "JUSTERA_LEVERANSPLAN_HEADER": "Justera leveransplan",
    "KUND_DETAIL_AKTIV": "Aktiv",
    "KUND_DETAIL_ANLAGGNING": "Anläggning",
    "KUND_DETAIL_AVTALSANSVARIG": "Avtalsansvarig",
    "KUND_DETAIL_BESKRIVNING": "Beskrivning",
    "KUND_DETAIL_BESOKSADRESS": "Besöksadress",
    "KUND_DETAIL_EJAKTIV": "Inaktiv",
    "KUND_DETAIL_HUVUDKOD": "Huvudkod",
    "KUND_DETAIL_INTERNNUMMER": "Internnummer",
    "KUND_DETAIL_LAND": "Land och landskod",
    "KUND_DETAIL_LIME": "i Lime",
    "KUND_DETAIL_LIMEID": "Lime ID",
    "KUND_DETAIL_NAMN": "Namn",
    "KUND_DETAIL_ORGNUMMER": "Organisationsnummer",
    "KUND_DETAIL_POSTADRESS": "Postadress",
    "KUND_DETAIL_STATUS_LIME": "Status i Lime",
    "KUND_DETAIL_TELEFON": "Telefon",
    "KUND_DETAIL_UPPDATERAD": "Uppdaterad",
    "KUND_HEADER": "Kunder",
    "CKLEVERANTOR_HEADER": "Leverantör CK",
    "KUND_LIST_AKTIV": "Aktiv",
    "KUND_LIST_AVDELNING": "Anläggning",
    "KUND_LIST_BESKRIVNING": "Beskrivning",
    "KUND_LIST_BESOKPOSTORTADRESS": "Besöksort",
    "KUND_LIST_HEADER_ORGNUMMER": "OrgNummer",
    "KUND_LIST_HUVUDKOD": "Huvudkod",
    "KUND_LIST_INTERNNUMMER": "Internnummer",
    "KUND_LIST_LIMEID": "Lime ID",
    "KUND_LIST_NAMN": "Namn",
    "KUND_LIST_ORGNUMMER": "Organisationsnummer",
    "KUND_LIST_SOK": "Sök kunder",
    "KUND_SOK_PLACEHOLDER": "Sök kundnamn, avtalsansvarig, anläggning",
    "CKLEVERANTOR_LIST_SOK": "Sök CK Leverantör",
    "KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER": "Alternativa mottagningsplatser",
    "KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_INGA_TILLAGDA": "Inga alternativa mottagningsplatser har lagts till",
    "KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_LABEL_AVLASTNINGSPLATS": "Avlastningsplats",
    "KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_LABEL_MOTTAGNINGSPLATS": "Mottagningsplats",
    "KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER_LAGG_TILL": "Lägg till",
    "KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT": "Alternativa handelssortiment",
    "KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT_INGA_TILLAGDA": "Inga alternativa handelssortiment har lagts till",
    "KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT_LABEL_MOTTAGNINGSPLATS": "Handelssortiment",
    "KUNDORDER_DETAIL_ALTERNATIVA_HANDELSSORTIMENT_LAGG_TILL": "Lägg till",
    "KUNDORDER_DETAIL_AVLASTNINGSPLATS": "Avlastningsplats",
    "KUNDORDER_DETAIL_AVTALSANSVARIG": "Avtalsansvarig Sveaskog",
    "KUNDORDER_DETAIL_TERMINALANSVARIG": "Terminalansvarig",
    "KUNDORDER_DETAIL_BALANS": "Balans",
    "KUNDORDER_DETAIL_BESKRIVNING": "Beskrivning",
    "KUNDORDER_DETAIL_BESOKSADRESS": "Besöksadress",
    "KUNDORDER_DETAIL_BUTTON_CREATE_NEW_KUNDORDERRAD": "Lägg till en ny kundorderrad",
    "KUNDORDER_DETAIL_BUTTON_DELETE_ORDERRAD": "Ta bort",
    "KUNDORDER_DETAIL_BUTTON_OVERVIEW": "Överblick",
    "KUNDORDER_DETAIL_BUTTON_SKAPA_KUNDORDER": "Skapa kundorder",
    "KUNDORDER_DETAIL_BUTTON_SPARA_KUNDORDER": "Spara kundorder",
    "KUNDORDER_DETAIL_CONST_FORSORJNINGSRAD_TYP_LEVERANTORSORDER": "LEVERANTORSORDER",
    "KUNDORDER_DETAIL_CONST_FORSORJNINGSRAD_TYP_PRODUKTIONSOMRADE": "PRODUKTIONSOMRADE",
    "KUNDORDER_DETAIL_CONST_FORSORJNINGSRAD_TYP_TERMINAL": "TERMINAL",
    "KUNDORDER_DETAIL_DELETE_FORSORJNINGSRAD_PROMPT_HEADER": "Ta bort försörjningsrad",
    "KUNDORDER_DETAIL_DELETE_FORSORJNINGSRAD_PROMPT_TEXT": "Vill du verkligen ta bort försörjningsraden?",
    "KUNDORDER_DETAIL_DELETE_PROMPT_HEADER": "Radera kundorder",
    "KUNDORDER_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av kundorder.",
    "KUNDORDER_DETAIL_DELETE_CONFIRM_LAGERTRANSAKTIONER_EXISTS": "<br/>{{samladeLagerplatser}} lagertransaktioner finns på kundordern, skall dessa kopplas bort?",
    "KUNDORDER_DETAIL_DELETE_CONFIRM_ROW_LAGERTRANSAKTIONER_EXISTS": "<br/>{{antalLagertransaktioner}} lagertransaktioner finns på den borttagna kundorderraden, skall dessa kopplas bort?",
    "KUNDORDER_DETAIL_DOLJ_PERIOD": "Dölj försörjning",
    "KUNDORDER_DETAIL_EDITERA": "Kundorder",
    "KUNDORDER_DETAIL_FORDELA_LEVERANSRAD": "Fördela på leveransrad",
    "KUNDORDER_DETAIL_FORDELNINGSANDEL": "Kvantitet att fördela",
    "KUNDORDER_DETAIL_FORSORJNINGSKALLA": "Produktionsområde, terminal eller leverantörsorder",
    "KUNDORDER_DETAIL_FORSORJNINGSRAD": "Försörjningsrad",
    "KUNDORDER_DETAIL_FORSORJNINGSRAD_ADD": " Lägg till försörjningsrad",
    "KUNDORDER_DETAIL_FORSORJNINGSRAD_KVANTITET_VALIDATION": "Du måste ange en positiv kvantitet",
    "KUNDORDER_DETAIL_FROM": "Från och med",
    "KUNDORDER_DETAIL_FROM_VALIDATION": "Du måste ange datum från och med",
    "KUNDORDER_DETAIL_HANDELSSORTIMENT": "Handelssortiment",
    "KUNDORDER_DETAIL_HANDELSSORTIMENT_VALIDATION": "Du måste ange handelssortiment",
    "KUNDORDER_DETAIL_HIDEDETAILS": "Dölj detaljer",
    "KUNDORDER_DETAIL_HS_EN_PRODUKT": "Handelssortimentet innehåller en produkt",
    "KUNDORDER_DETAIL_HS_FLERA_PRODUKTER": "Handelssortimentet innehåller flera produkter",
    "KUNDORDER_DETAIL_HUVUDKOD_INTERNNUMMER": "Huvudkod internnr",
    "KUNDORDER_DETAIL_IBY": "Skapad av",
    "KUNDORDER_DETAIL_KOPARKONTRAKT": "Köparkontrakt",
    "KUNDORDER_DETAIL_KUND": "Kund",
    "KUNDORDER_DETAIL_KUND_VALIDATION": "Du måste ange kund",
    "KUNDORDER_DETAIL_KUNDORDERRAD_DELETE_MINSTENRAD": "Kundorderraden kan inte tas bort, minst en rad på ordern",
    "KUNDORDER_DETAIL_KUNDORDERRAD_DELETE_PERIODPABORJAD": "Kundorderraden kan inte tas bort, eftersom dess period är påbörjad",
    "KUNDORDER_DETAIL_KUNDORDERRAD_DELETE_PROMPT_HEADER": "Ta bort kundorderrad",
    "KUNDORDER_DETAIL_KUNDORDERRAD_DELETE_PROMPT_TEXT": "Vill du verkligen ta bort kundorderraden med perioden ",
    "KUNDORDER_DETAIL_MANUELLPAAO": "Manuell på AO",
    "KUNDORDER_DETAIL_EGENSKAPSKODX": "Egenskapskod X",
    "KUNDORDER_DETAIL_EJVIRKESKOP": "Ej Virkesköp/Centrala virkesköp",
    "KUNDORDER_DETAIL_KVANTITET": "Avtalskvantitet",
    "KUNDORDER_DETAIL_KVANTITET_VALIDATION": "Du måste ange avtalskvantitet",
    "KUNDORDER_DETAIL_LABEL_GROUP_LEVERANTORSORDER": "Leverantörsorder",
    "KUNDORDER_DETAIL_LABEL_GROUP_PRODUKTIONSOMRADE": "Produktionsområde",
    "KUNDORDER_DETAIL_LABEL_GROUP_TERMINAL": "Terminal",
    "KUNDORDER_DETAIL_MATTSLAG": "Måttslag",
    "KUNDORDER_DETAIL_MATTSLAG_VALIDATION": "Du måste ange måttslag",
    "KUNDORDER_DETAIL_MOTTAGNINGSPLATS": "Mottagningsplats",
    "KUNDORDER_DETAIL_MOTTAGNINGSPLATS_VALIDATION": "Du måste ange mottagningsplats",
    "KUNDORDER_DETAIL_ORDERNUMMER": "Ordernummer",
    "KUNDORDER_DETAIL_ORDERRAD": "kundorderrad",
    "KUNDORDER_DETAIL_PERIODTYP": "Periodtyp",
    "KUNDORDER_DETAIL_PERIODTYP_MANAD": "Månad",
    "KUNDORDER_DETAIL_PERIODTYP_VALIDATION": "Du måste ange periodtyp",
    "KUNDORDER_DETAIL_PERIODTYP_VECKA": "Vecka",
    "KUNDORDER_DETAIL_SHOWDETAILS": "Visa detaljer",
    "KUNDORDER_DETAIL_SKAPA_KUNDORDERRAD": "Skapa orderrad",
    "KUNDORDER_DETAIL_VISA_LOGG": "Visa logg",
    "KUNDORDER_DETAIL_LAGG_TILL": "Lägg till ny kundorderrad",
    "KUNDORDER_DETAIL_SKAPA_NY": "Skapa ny kundorder",
    "KUNDORDER_DETAIL_SUMMA_LEVERANSRADER": "Summa leveransrader",
    "KUNDORDER_DETAIL_TILLGANGLIG_KVANTITET": "Tillgänglig kvantitet",
    "KUNDORDER_DETAIL_TITLE_NEW_ORDERRAD": "Ny kundorderrad",
    "KUNDORDER_DETAIL_TOM": "Till och med",
    "KUNDORDER_DETAIL_TOM_VALIDATION": "Du måste ange datum till och med",
    "KUNDORDER_DETAIL_TOOLTIP_ANDRA_FORSORJNINGSRAD": "Ändra försörjningsrad",
    "KUNDORDER_DETAIL_TOOLTIP_RADERA_FORSORJNINGSRAD": "Ta bort försörjningsrad",
    "KUNDORDER_DETAIL_TYPE_AHEAD_HELP_TEXT": "Ange minst tre tecken",
    "KUNDORDER_DETAIL_TYPE_AHEAD_NO_RESULT": "Inget resultat",
    "KUNDORDER_DETAIL_UBY": "Senast uppdaterad av",
    "KUNDORDER_DETAIL_VISA_PERIOD": "Visa försörjning",
    "KUNDORDER_HEADER": "Kundorder",
    "KUNDORDER_HEADER_PREVIEW": "Kundorder (New)",
    "KUNDORDER_LEVRADER_ANDRA": "Ändra",
    "KUNDORDER_LEVRADER_HEADER_ANDRA_FORSORJNINGSRAD": "Ändra försörjningsrad",
    "KUNDORDER_LEVRADER_HEADER_AVVIKELSE": "Avvikelse",
    "KUNDORDER_LEVRADER_HEADER_BALANS": "Balans",
    "KUNDORDER_LEVRADER_HEADER_HELA_PERIODEN": "Hela perioden",
    "KUNDORDER_LEVRADER_HEADER_LEVERANSRAD": "Leveransrad",
    "KUNDORDER_LEVRADER_HEADER_BALANS_TOOLTIP": "Balans visar differans mellan leveransrad och transporterat för tidigare perioder och differans mellan leveransrad och försöjningsrad för innevarande och kommande perioder. Radsummering sker endast på innevarande och kommande perioder.",
    "KUNDORDER_LEVRADER_HEADER_PLAN": "Plan",
    "KUNDORDER_LEVRADER_HEADER_PLANTRANSPORTERAT": "Plan/Transporterat",
    "KUNDORDER_LEVRADER_HEADER_SUMMA": "Summa",
    "KUNDORDER_LEVRADER_HEADER_SUMMA_BALANS": "Balans",
    "KUNDORDER_LEVRADER_HEADER_FORSORJNINGSGRADER": "Försörjningsrader",
    "KUNDORDER_LEVRADER_HEADER_SUMMA_LEVERANS": "Leveransrad",
    "KUNDORDER_LEVRADER_HEADER_SUMMA_PLAN": "Plan",
    "KUNDORDER_LEVRADER_HEADER_SUMMA_TRANSPORTERAT": "Transporterat",
    "KUNDORDER_LEVRADER_HEADER_TRANSPORTERAT": "Transporterat",
    "KUNDORDER_LEVRADER_HEADER_TAKT_MAN": "Takt mån.",
    "KUNDORDER_LEVRADER_HEADER_OVERENSKOMMET": "Överenskommet",
    "KUNDORDER_LEVRADER_HEADER_TRANSPORTERAT_LEVERANSRAD": "Transp.+leveransrad",
    "KUNDORDER_LEVRADER_TAKT": "Takt",
    "KUNDORDER_LEVRADER_TAKT_STATUS": "{{dagarKvar}} av {{totaltAntalDagar}} dgr kvar på inn. mån.",
    "KUNDORDER_LIST_AVTALSANSVARIG": "Avtalsansvarig",
    "KUNDORDER_LIST_TERMINALANSVARIG": "Terminalansvarig",
    "KUNDORDER_LIST_BESKRIVNING": "Beskrivning",
    "KUNDORDER_LIST_HANDELSSORTIMENT": "Handelssortiment",
    "KUNDORDER_LIST_KUND": "Kund Huvudkod Internnummer",
    "KUNDORDER_LIST_KUNDNAMN": "Kundnamn",
    "KUNDORDER_LIST_KVANTITET": "Kvantitet",
    "KUNDORDER_LIST_MOTTAGNINGSPLATS": "Mottagningsplats",
    "KUNDORDER_LIST_ORDERNUMMER": "Ordernummer",
    "KUNDORDER_LIST_PERIODFROM": "Period fr.o.m.",
    "KUNDORDER_LIST_PERIODTOM": "Period t.o.m.",
    "KUNDORDER_LIST_SKAPA_NY": "Skapa ny kundorder",
    "KUNDORDER_LIST_SOK": "Sök kundorder",
    "KUNDORDER_UNDO_ORDER": "Ångra ändringar",
    "LAGERMAL_DETAIL_BUTTON_HAMTA": "Hämta lagermål",
    "LAGERMAL_DETAIL_LABEL_DAYS": "Antal dagar",
    "LAGERMAL_DETAIL_LABEL_MARKNADSOMRADE": "Marknadsområde",
    "LAGERMAL_DETAIL_LABEL_PRODUKTIONSOMRADE": "Produktionsområde",
    "LAGERMAL_DETAIL_LABEL_QUANTITY": "Kvantitet i m3f",
    "LAGERMAL_DETAIL_MATRIS_HEAD_APR": "April",
    "LAGERMAL_DETAIL_MATRIS_HEAD_AUG": "Augusti",
    "LAGERMAL_DETAIL_MATRIS_HEAD_DEC": "December",
    "LAGERMAL_DETAIL_MATRIS_HEAD_FEB": "Februari",
    "LAGERMAL_DETAIL_MATRIS_HEAD_HANDELSSORTIMENT": "Handelssortiment",
    "LAGERMAL_DETAIL_MATRIS_HEAD_JAN": "Januari",
    "LAGERMAL_DETAIL_MATRIS_HEAD_JUL": "Juli",
    "LAGERMAL_DETAIL_MATRIS_HEAD_JUN": "Juni",
    "LAGERMAL_DETAIL_MATRIS_HEAD_MAJ": "Maj",
    "LAGERMAL_DETAIL_MATRIS_HEAD_MAR": "Mars",
    "LAGERMAL_DETAIL_MATRIS_HEAD_NOV": "November",
    "LAGERMAL_DETAIL_MATRIS_HEAD_OKT": "Oktober",
    "LAGERMAL_DETAIL_MATRIS_HEAD_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "LAGERMAL_DETAIL_MATRIS_HEAD_SEP": "September",
    "LAGERMAL_DETAIL_MATRIS_HEAD_STANDARDVARDE": "Standardvärde",
    "LAGERMAL_DETAIL_SOEK": "Hantera lagermål",
    "LAGERMAL_HEADER": "Lagermål",
    "LAGERMAL_IGNORE_CHANGED_DATA_PROMPT_HEADER": "Ignorera ändrad data",
    "LAGERMAL_IGNORE_CHANGED_DATA_PROMPT_TEXT": "Du har osparad data. Vill du fortsätta?",
    "LAGERMAL_MENU_LINK_LABEL": "Lista och redigera",
    "LAGERPLATS_DETAIL_ERROR_ANDEL_VALUE": "Värdet får inte överstiga 100%",
    "LAGERPLATS_DETAIL_ERROR_FROM": "Fr.o.m. saknas",
    "LAGERPLATS_DETAIL_ERROR_NO_PRODUKT": "Produkt saknas",
    "LAGERPLATS_DETAIL_ERROR_SORTIMENTKOD": "Sortimentskod saknas",
    "LEVERANS_HEADER": "Leverans",
    "LEVERANTORSORDER_DETAIL_AVTALANSVARIG": "Avtalsansvarig Sveaskog",
    "LEVERANTORSORDER_DETAIL_BESOKSADRESS": "Besöksadress",
    "LEVERANTORSORDER_DETAIL_BUTTON_OVERVIEW": "Översikt",
    "LEVERANTORSORDER_DETAIL_COUNTORDERRAD": "Totalt {{count}} st leverantörsorderrad(er)",
    "LEVERANTORSORDER_DETAIL_DELETE_PROMPT_HEADER": "Radera leverantörsorder",
    "LEVERANTORSORDER_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av leverantörsorder",
    "LEVERANTORSORDER_DETAIL_DELETE_CONFIRM_LAGERTRANSAKTIONER_EXISTS": "<br/>{{samladeLagerplatser}} lagertransaktioner finns på leverantörsordern, skall dessa kopplas bort?",
    "LEVERANTORSORDER_DETAIL_DELETE_CONFIRM_ROW_LAGERTRANSAKTIONER_EXISTS": "<br/>{{antalLagertransaktioner}} lagertransaktioner finns på den borttagna leverantörsorderraden, skall dessa kopplas bort?",
    "LEVERANTORSORDER_DETAIL_DETAIL_ROW_DELETE_PROMPT_HEADER": "Ta bort leverantörsorderrad",
    "LEVERANTORSORDER_DETAIL_DETAIL_ROW_DELETE_PROMPT_TEXT": "Vill du verkligen ta bort leverantörsorderrad ?",
    "LEVERANTORSORDER_DETAIL_FORSORJNING": "Leveransrad",
    "LEVERANTORSORDER_DETAIL_FORSORJNINGSKALLA": "Mottagningsplats",
    "LEVERANTORSORDER_DETAIL_FROM": "Från",
    "LEVERANTORSORDER_DETAIL_HIDEDETAILS": "Dölj detaljer",
    "LEVERANTORSORDER_DETAIL_HUVUDKOD_INTERNNUMMER": "Huvudkod internnr",
    "LEVERANTORSORDER_DETAIL_HVKODLEV": "Leverantörsnamn",
    "LEVERANTORSORDER_DETAIL_HVKODLEV_VALIDATION": "Du måste ange leverantör",
    "LEVERANTORSORDER_DETAIL_IBY": "Skapad av",
    "LEVERANTORSORDER_DETAIL_KONTAKTTILLLEV": "Kontakt till leverantören",
    "LEVERANTORSORDER_DETAIL_LABEL_GROUP_LEVERANTORSORDER": "Mottagningsplats",
    "LEVERANTORSORDER_DETAIL_LABEL_GROUP_TERMINAL": "Terminal",
    "LEVERANTORSORDER_DETAIL_LEVERANTORSORDER": "Leverantörsorder",
    "LEVERANTORSORDER_DETAIL_NYLEV": "Lägg till ny leverantörsorderrad",
    "LEVERANTORSORDER_DETAIL_ORDERNUMMER": "Ordernummer",
    "LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODFRAN": "Från",
    "LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODFRAN_VALIDATION": "Du måste ange datum från och med",
    "LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODTOM": "Tom",
    "LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODTOM_VALIDATION": "Du måste ange datum till och med",
    "LEVERANTORSORDER_DETAIL_ROW_KVANTITET": "Avtalskvantitet",
    "LEVERANTORSORDER_DETAIL_ROW_KVANTITET_VALIDATION": "Du måste ange avtalskvantitet",
    "LEVERANTORSORDER_DETAIL_ROW_MATTSLAG": "Måttslag",
    "LEVERANTORSORDER_DETAIL_ROW_MATTSLAG_VALIDATION": "Du måste ange måttslag",
    "LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP_VALIDATION": "Du måste ange handelssortimentsgrupp",
    "LEVERANTORSORDER_DETAIL_SHOWDETAILS": "Visa detaljer",
    "LEVERANTORSORDER_DETAIL_SKAPA": "Skapa leveranstörsorder",
    "LEVERANTORSORDER_DETAIL_SKAPALEVERANTORSORDER": "Skapa leverantörsorder",
    "LEVERANTORSORDER_DETAIL_SKAPANYORDERRAD": "Lägg till ny leverantörsorderrad",
    "LEVERANTORSORDER_DETAIL_SPARA": "Spara leverantörsorder",
    "LEVERANTORSORDER_DETAIL_STATUS": "Status",
    "LEVERANTORSORDER_DETAIL_STATUS_KONTRAKT": "Kontrakt",
    "LEVERANTORSORDER_DETAIL_STATUS_PROGNOS": "Prognos",
    "LEVERANTORSORDER_DETAIL_TOM": "Till",
    "LEVERANTORSORDER_DETAIL_TYPE_AHEAD_HELP_TEXT": "Ange minst tre tecken",
    "LEVERANTORSORDER_DETAIL_TYPE_AHEAD_NO_RESULT": "Inget resultat",
    "LEVERANTORSORDER_DETAIL_UBY": "Senast uppdaterad av",
    "LEVERANTORSORDER_DOLJ_RAD": "Dölj leveransrad",
    "LEVERANTORSORDER_EGEN_BEFRAKTNING": "Befraktare Sveaskog",
    "LEVERANTORSORDER_HEADER": "Leverantörsorder",
    "LEVERANTORSORDER_HEADER_PREVIEW": "Leverantörsorder (New)",
    "LEVERANTORSORDER_LIST_AVTALSANSVARIG": "Avtalsansvarig",
    "LEVERANTORSORDER_LIST_FROM": "Från och med",
    "LEVERANTORSORDER_LIST_HVKODLEV": "Huvudkod/Leverantörsnamn",
    "LEVERANTORSORDER_LIST_LEVERANTOR": "Leverantör Huvudkod Internnummer",
    "LEVERANTORSORDER_LIST_MOTTAGNINNGSPLATS": "Mottagningsplats",
    "LEVERANTORSORDER_LIST_OBALANS": "Med obalans",
    "LEVERANTORSORDER_LIST_ORDERNUMMER": "Ordernummer",
    "LEVERANTORSORDER_LIST_ORDERSOK": "Sök leverantörsorder",
    "LEVERANTORSORDER_LIST_ORDERSOK_PLACEHOLDER": "Sök leverantör, huvudkod, produktgrupp eller avtalsansvarig",
    "LEVERANTORSORDER_LIST_PERIODFROM": "Period fr.o.m.",
    "LEVERANTORSORDER_LIST_PERIODTOM": "Period t.o.m.",
    "LEVERANTORSORDER_LIST_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "LEVERANTORSORDER_LIST_SKAPANYLEV": "Skapa ny leverantörsorder",
    "LEVERANTORSORDER_LIST_STATUS": "Status",
    "LEVERANTORSORDER_LIST_TOM": "Till och med",
    "LEVERANTORSORDER_TYPE_AHEAD_NO_RESULT": "Inget resultat",
    "LEVERANTORSORDER_VISA_RAD": "Visa leveransrad",
    "LOGIN_ACCEPT_COOKIES_HEADER": "Medgivande till användningen av cookies",
    "LOGIN_ACCEPT_COOKIES_MESSAGE": "För att logga in i RASK måste du acceptera att cookies lagras på din dator.",
    "LOGIN_HEADER": "Logga in",
    "LOGIN_LOGIN": "Logga in",
    "LOGIN_LOGOUT": "Logga ut",
    "LOGIN_PASSWORD": "Lösenord",
    "LOGIN_PASSWORD_VALIDATION": "Lösenord måste anges",
    "LOGIN_TWO_FACTOR_AUTH": "SMS-inloggning",
    "LOGIN_TWO_FACTOR_CANCEL_BUTTON": "Avbryt",
    "LOGIN_TWO_FACTOR_CODE": "SMS-kod",
    "LOGIN_TWO_FACTOR_OK_BUTTON": "OK",
    "LOGIN_USER_NAME": "Användarnamn",
    "LOGIN_USERNAME_VALIDATION": "Användarnamn måste anges",
    "LOGIN_RASK_VERSION_UPDATE": "Rask har uppdaterats till en ny version och du behöver logga in igen.",
    "MAP_DRAW": "Rita",
    "MAP_RESIZE_ENLARGE_VIEW": "Öka bredd",
    "MAP_RESIZE_RETRACT_VIEW": "Minska bredd",
    "MATTSLAGSKONVERTERING_HEADER": "Måttslagskonvertering",
    "MEDDELANDEINFOTAVLA_LABEL_LAS_MER": "Läs mer",
    "MEDDELANDEINFOTAVLA_HEADER": "Systemaktivitet",
    "MINAMASKINLAG_HEADER": "Mina maskinlag",
    "MINAPRODUKTIONSMALLAR_HEADER": "Mina produktionsmallar",
    "SANDNINGSLOGG_HEADER": "Skickade apteringsfiler",
    "PRODUKTINSTRUKTION_HEADER": "Produktinstruktioner",
    "SOKEXTERNARBETSORDER_HEADER": "Extern arbetsorder",
    "CKPRODUKTIONSMALL_HEADER": "Externa produktionsmallar",
    "MINAPRODUKTIONSMALLAR_NAMN": "Namn",
    "MINAPRODUKTIONSMALLAR_SENAST_ANDRAD": "Senast ändrad",
    "MINAPRODUKTIONSMALLAR_TA_BORT": "Ta bort mall",
    "MINAPRODUKTIONSMALLAR_REDIGERA_HEADER": "Redigera produktionsmall",
    "MINAPRODUKTIONSMALLAR_REDIGERA_BENAMNING": "Namn på mall",
    "MINAPRODUKTIONSMALLAR_REDIGERA_INNEHALL": "Innehåll för produktionsmall",
    "MINAPRODUKTIONSMALLAR_REDIGERA_FILTRERA_URVAL": "Filtrera urval av handelssortiment",
    "MINAPRODUKTIONSMALLAR_TA_BORT_CONFIRM_HEADER": "Ta bort produktionsmall",
    "MINAPRODUKTIONSMALLAR_TA_BORT_CONFIRM_MESSAGE": "Vill du verkligen ta bort produktionsmallen?",
    "MINAPRODUKTIONSMALLAR_MALL_NOT_VALID_SET_UNIQUE_BENAMNING": "Produktionsmallen måste ha en unik benämning.",
    "MINAPRODUKTIONSMALLAR_MALL_NOT_VALID_SELECT_HANDELSSORTIMENT": "Minst ett handelssortiment måste vara valt.",
    "MINAPRODUKTIONSMALLAR_SPARA": "Spara mall",
    "MINAPRODUKTIONSMALLAR_INGEN_PRODUKT": "(Ingen produkt vald)",
    "MINAPRODUKTIONSMALLAR_INGEN_PRODUKTINSTRUKTION": "(Ingen produktinstruktion vald)",
    "MINAFORKALKYLSMALLAR_HEADER": "Mina förkalkylsmallar",
    "MOTTAGNINGSPLATS_DETAIL_AKTIV": "Aktiv",
    "MOTTAGNINGSPLATS_DETAIL_ANSVARIGLOGISTIKER": "Ansvarig logistiker",
    "MOTTAGNINGSPLATS_DETAIL_AVLAMNINGSPLATS": "Avlastningsplats",
    "MOTTAGNINGSPLATS_DETAIL_BESKRIVNING": "Beskrivning",
    "MOTTAGNINGSPLATS_DETAIL_DELETE_PROMPT_HEADER": "Radera mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_EDITERA": "Mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_ERROR_MOTTAGNINGSPLATSNUMMER": "Du måste ange ett giltigt mottagningsplatsnummer",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINAT": "Koordinater",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINATE": "E",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINATER": "Koordinater",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINATER_E": "E",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINATER_N": "N",
    "MOTTAGNINGSPLATS_DETAIL_KOORDINATN": "N",
    "MOTTAGNINGSPLATS_DETAIL_KUNDENSMOTTAGNINGSPLATS": "Kundens mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_LAND": "Land",
    "MOTTAGNINGSPLATS_DETAIL_LAND_VALIDATION": "Du måste ange ett land",
    "MOTTAGNINGSPLATS_DETAIL_LEVERANSKALENDER": "Leveranskalender",
    "MOTTAGNINGSPLATS_DETAIL_MATMETODER": "Mätmetoder",
    "MOTTAGNINGSPLATS_DETAIL_MOTTAGNINGSPLATSNUMMER": "Mottagningsplatsnummer",
    "MOTTAGNINGSPLATS_DETAIL_MOTTAGNINGSPLATSTYP": "Mottagningsplatstyp",
    "MOTTAGNINGSPLATS_DETAIL_NAMN": "Namn",
    "MOTTAGNINGSPLATS_DETAIL_NAMN_VALIDATION": "Du måste ange ett mottagningsplatsnamn",
    "MOTTAGNINGSPLATS_DETAIL_OPPETTIDER": "Öppettider",
    "MOTTAGNINGSPLATS_DETAIL_SDCUPDATE_BEKRAFTA": "Bekräfta",
    "MOTTAGNINGSPLATS_DETAIL_SDCUPDATE_INGENTRAFF": "Ingen SDC-Mottagningsplatskod hittades",
    "MOTTAGNINGSPLATS_DETAIL_SDCUPDATE_TEXT": "Vill du uppdatera namn och koordinater från SDC mottagningsplats?",
    "MOTTAGNINGSPLATS_DETAIL_SKAPA_NY": "Lägg upp mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_SKAPA_NY_UTLANDSK": "Skapa utländsk mottagningsplats",
    "MOTTAGNINGSPLATS_DETAIL_SVEASKOGTERMINAL": "Sveaskogs terminal",
    "MOTTAGNINGSPLATS_DETAIL_TERMINAL": "Terminal",
    "MOTTAGNINGSPLATS_DETAIL_TERMINALVALEN": "Terminalval",
    "MOTTAGNINGSPLATS_DETAIL_LEVERANTORS_VALIDATION": "Du måste ange en leverantör",
    "MOTTAGNINGSPLATS_DETAIL_KUND_VALIDATION": "Du måste ange en kund",
    "MOTTAGNINGSPLATS_HEADER": "Mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_AKTIV": "Aktiv",
    "MOTTAGNINGSPLATS_LIST_ANSVARIGLOGISTIKER": "Ansvarig logistiker",
    "MOTTAGNINGSPLATS_LIST_BESKRIVNING": "Beskrivning",
    "MOTTAGNINGSPLATS_LIST_KUNDENSMOTTAGNINGSPLATS": "Kundens mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATS": "Mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATSNUMMER": "Mottagningsplatsnummer",
    "MOTTAGNINGSPLATS_LIST_MOTTAGNINGSPLATSTYP": "Mottagningsplatstyp",
    "MOTTAGNINGSPLATS_LIST_MPLTYP": "Mpl_Typ",
    "MOTTAGNINGSPLATS_LIST_NAMN": "Namn",
    "MOTTAGNINGSPLATS_LIST_SKAPA_NY": "Lägg upp mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_SKAPA_NY_UTLANDSK": "Skapa utländsk mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_SOK": "Sök mottagningsplats",
    "MOTTAGNINGSPLATS_LIST_SVEASKOGTERMINAL": "Sveaskogs terminal",
    "MOTTAGNINGSPLATS_LIST_TERMINAL": "Terminal",
    "NAVIGATION_UNSAVEDDATA_BUTTON_CANCEL": "Avbryt",
    "NAVIGATION_UNSAVEDDATA_BUTTON_SAVE": "Spara",
    "NAVIGATION_UNSAVEDDATA_BUTTON_YES": "Spara inte",
    "NAVIGATION_UNSAVEDDATA_PROMPT_HEADER": "Vill du spara dina ändringar?",
    "NAVIGATION_UNSAVEDDATA_PROMPT_TEXT": "Du kommer att förlora dina ändringar om du inte sparar.",
    "NAVIGATION_VIEW_UNSAVEDDATA_BUTTON_CANCEL": "Avbryt",
    "NAVIGATION_VIEW_UNSAVEDDATA_BUTTON_YES": "Ja, lämna sidan",
    "NAVIGATION_VIEW_UNSAVEDDATA_PROMPT_HEADER": "Vill du lämna denna vy utan att spara?",
    "NAVIGATION_VIEW_UNSAVEDDATA_PROMPT_TEXT": "Du kommer att förlora dina ändringar om du lämnar denna vy. Välj avbryt om du vill stanna kvar så att du kan spara ändringarna.",
    "NOT_AUTHORIZED": "401 - Obehörig",
    "MAINTENANCE_MODE": "RASK är för närvarande inte tillgängligt",
    "NOTIFY_HEADER": "Meddelande",
    "OVERVAKNING_HEADER": "Övervakning",
    "JUSTERA_LEVERANSPLAN_SPARA_SOKNING": "Spara sökning",
    "JUSTERA_LEVERANSPLAN_ANGE_NAMN": "Ange namn",
    "JUSTERA_LEVERANSPLAN_DET_FINNS_REDAN_SOKNING": "Det finns redan en sökning med detta namn",
    "JUSTERA_LEVERANSPLAN_GAR_EJ_ATT_SPARA_FLER_SOKNINGAR": "Det går ej att spara fler sökningar. Du kan ersätta eller ta bort en sökning",
    "JUSTERA_LEVERANSPLAN_TA_BORT_SOKNING": "Ta bort sökning",
    "JUSTERA_LEVERANSPLAN_BEKRAFTA_BORTTAGNING_AV": "Bekräfta borttag av ",
    "JUSTERA_LEVERANSPLAN_VILL_DU_SKRIVA_OVER": "Vill du skriva över ",
    "JUSTERA_LEVERANSPLAN_AREASELECTOR": "MO/RO/PO",
    "JUSTERA_LEVERANSPLAN_AVTALSANSVARIG": "Avtalsansvarig",
    "JUSTERA_LEVERANSPLAN_BALANSERA": "Justera leveransplan",
    "JUSTERA_LEVERANSPLAN_EMPTY_RESULT": "Ingen order hittades.",
    "JUSTERA_LEVERANSPLAN_HANDELSSORTIMENT": "Handelssortiment",
    "JUSTERA_LEVERANSPLAN_SELECT_ALL_HANDELSSORTIMENT": "Välj alla handelssortiment",
    "JUSTERA_LEVERANSPLAN_KUNDNAMN": "Kund",
    "JUSTERA_LEVERANSPLAN_KUNDORDER_URVAL": "Urval för kundorder",
    "JUSTERA_LEVERANSPLAN_LAGERPLATS": "Mottagningsplats",
    "JUSTERA_LEVERANSPLAN_LEVERANTOR": "Leverantör",
    "JUSTERA_LEVERANSPLAN_LEVERANTORSORDER_URVAL": "Urval för leverantörsorder",
    "JUSTERA_LEVERANSPLAN_OBALANS": "Visa rader med obalans",
    "JUSTERA_LEVERANSPLAN_PERIODFROM": "Period fr.o.m",
    "JUSTERA_LEVERANSPLAN_PERIODTOM": "Period t.o.m",
    "JUSTERA_LEVERANSPLAN_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp",
    "JUSTERA_LEVERANSPLAN_PRODUKTIONSOMRADE": "Produktionsområde",
    "JUSTERA_LEVERANSPLAN_PRODUKTIONSOMRADE_URVAL": "Urval för produktionsområden",
    "JUSTERA_LEVERANSPLAN_TAB_KUNDORDER": "Kundorder",
    "JUSTERA_LEVERANSPLAN_TAB_LEVERANTORSORDER": "Leverantörsorder",
    "JUSTERA_LEVERANSPLAN_TAB_PRODUKTIONSOMRADE": "Produktionsområden",
    "JUSTERA_LEVERANSPLAN_VISA_DATUMVALJAREN": "Visa datumväljare",
    "JUSTERA_LEVERANSPLAN_DOLJ_DATUMVALJAREN": "Dölj",
    "PLANERA_ARBETSORDER_DETAIL_ADD_PRODUKTGRUPP": "Lägg till produktgrupp",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA": "Destinera",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_OM": "Destinera om",
    "PLANERA_ARBETSORDER_DETAIL_KONTRAKTSRADER": "Kontraktsrader",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_ANDEL": "Andel",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_ALTERNATIVT": "Alternativt handelssortiment",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_MOTTAGNINGSPLATS": "Mottagningsplats",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_TRANSPORTAVSTAND": "Transportavstånd",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_NO_RESULT": "Destinering resulterade inte i någon träff mot kundorderrader.",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERA_KUNDORDERRAD_SAKNAS": "Det saknas kundorderrad för handelssortimentet",
    "PLANERA_ARBETSORDER_DETAIL_INFO_SUMMA": "Summa",
    "PLANERA_ARBETSORDER_DETAIL_INFO_ENHET": " %",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TIMMERANDEL": "Timmerandel",
    "PLANERA_ARBETSORDER_DETAIL_INFO_GROT_SCHABLON": "Grot (schablon)",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING": "Anteckningar",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_GRUPPERINGSANTECKNING": "Grupperingsanteckning",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_UTTAGSANVISNING": "Uttagsanvisning",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_KONTRAKTSANTECKNINGAVVERKNINGSDIREKTIV": "Kontraktsanteckning Avverkningsdirektiv",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_KONTRAKTSANTECKNINGTRANSPORTORDER": "Kontraktsanteckning Transportorder",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_PRODUKTIONSPLANERINGSANTECKNING": "Anteckning till avverkningsdirektiv och maskinens apteringsfiler",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_ANTECKNING_VIRKESORDERANTECKNING": "Anteckning till virkesordern",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_DOKUMENT": "Dokument",
    "PLANERA_ARBETSORDER_DETAIL_HANDELSELOGG": "Händelselogg",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING": "Sammanfattning",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_DATUM": "Periodsätt arbetsorder",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_DATUMINTERVALL": "Datumintervall",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_GYL": "GYL",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_HA": "HA",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_M3FUB": "Uttag m3f",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_NAMN": "Namn",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_UPPDRAG": "Uppdrag",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VIRKETMARKT": "Virket märkt",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_PRODUKTIONSSTATUS": "Produktionsstatus",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_PRODUKTION_GODKAND": "Arbetsorder avslutad",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_INGAR_I_KONTRAKT": "Ingår i kontrakt",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VIRKESKOPARE": "Virkesköpare",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_LEVERANTOR": "Leverantör",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_PLANERINGSSTATUS": "Planeringsstatus",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VILLKOR": "Villkor",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_GROTANPASSING": "Grotanpassning",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VIRKESORDER_VIOL2": "Virkesorder",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_SKORDAD": "Skördad",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_SKORDAD_AV": "Skördad av",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_RELATERAD_AO_RV": "Relaterad AO Rundvirke",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_RELATERAD_AO_GROT": "Relaterad AO Grot",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_LEVERANSSASONG": "Leveranssäsong",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_RELATERAD_ATGARD_RV": "Relaterad åtgärd Rundvirke",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_RELATERAD_ATGARD_GROT": "Relaterad åtgärd Grot",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_LANK_TILL_PROLOG": "Länk till ProLog",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VO_STATUS": "Virkesorderstatus",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_VIOL3_STATUS": "VIOL3-Status",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTE": "Utbyte",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING": "Direktutbyte",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_LABEL_ANDRA": "Ändra till",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_LABEL_PRODUKTGRUPP": "Produktgrupp",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_LABEL_PRODUKTGRUPP_LOWERCASE": "produktgrupp",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_LABEL_VOLYM": "Volym m3fub",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_SAVE_MODAL_BODY": "Om du utbytessimulerar utan att spara först kommer du att förlora dina ändringar.",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_SAVE_MODAL_SAVEBUTTON": "Spara och utbytessimulera",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_SAVE_MODAL_TITLE": "Vill du spara dina ändringar innan du utbytessimulerar?",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_HAMTA_VAL_VOLYMER_SAVE_MODAL_BODY": "Om du hämtar val och volymer utan att spara först kommer du att förlora dina ändringar.",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_HAMTA_VAL_VOLYMER_SAVE_MODAL_SAVEBUTTON": "Spara och hämta val",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_HAMTA_VAL_VOLYMER_SAVE_MODAL_TITLE": "Vill du spara dina ändringar innan du hämtar val och volymer?",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_RENSAVAL_MODAL_BODY": "Om du inte sparar efter så sparas inte din rensning av handelssortiment.",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_RENSAVAL_MODAL_SAVEBUTTON": "Rensa handelssortiment",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_RENSAVAL_MODAL_TITLE": "Rensa valda handelssortiment?",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_VISA_TRADSLAGSDATA": "Visa skoglig info",
    "PLANERA_ARBETSORDER_DETAIL_INFO_TAB_UTBYTESBERAKNING_DOLJ_TRADSLAGSDATA": "Dölj skoglig info",
    "PLANERA_ARBETSORDER_DETAIL_ALLA_INGAENDE_ATGARDER": "Alla ingående åtgärder",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER": "Ingående åtgärder",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_ANSVARIG_PLANERARE": "Ansvarig för fältplanering",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_ATGARDSTYP": "Åtgärdstyp",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_BYL": "BYL",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_HEKTAR": "HA",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_MEDELSTAM": "Medelstam",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_PLANERATDATUM": "Planerat datum",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_RETURNERATILLGISS_TITLE": "Returnera till GISS",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_RETURNERATILLGISS_BODY": "Är du helt säker på att du vill returnera åtgärden till GISS?",
    "PLANERA_ARBETSORDER_DETAIL_OVERRIDE_GROTANPASSA_TITLE": "Grotanpassa",
    "PLANERA_ARBETSORDER_DETAIL_OVERRIDE_GROTANPASSA_BODY": "Du har valt att grotanpassa en åtgärd där grot ej är föreslagen i GISS. Observera att anmälan om grotuttag måste skickas till Skogsstyrelsen. Vill du gå vidare?",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_RETURNERATILLGISS_BUTTON": "Skicka i retur till GISS",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_RETURNERATILLGISS_FAILED": "Negativt svar från Navet/Giss. Åtgärden gick ej att returnera!",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_TABORT_TITLE": "Ta bort åtgärd?",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_TABORT_BODY": "Är du helt säker på att du vill ta bort åtgärden? Arbetsordern kommer att laddas om.",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_TABORT_BUTTON": "Ta bort",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_TILLGANGLIGHET_SKOG": "Skog",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_TILLGANGLIGHET_VAG": "Väg",
    "PLANERA_ARBETSORDER_DETAIL_INGAENDE_ATGARDER_VALJ_ATGARD": "Välj åtgärd",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER": "Drivningspunkter",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_AVLAGG": "Avlägg",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_KOJPLATS": "Kojplats",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_LARMKOORDINAT": "Larmkoordinat",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_LARMPUNKT": "Larmpunkt",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER": "Verifiera drivningspunkter",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_AVLAGG": "Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_KOJPLATS": "Minst en kojplats",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_L1": "Verifiera att arbetsorderns drivningspunkter ligger i anslutning till maskinlagets arbetsområde.",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_L2": "För att verifiera arbetsorderns drivningspunkter behöver det finnas:",
    "PLANERA_ARBETSORDER_DETAIL_KOORDINATER_VERIFIERA_DRIVNINGSPUNKTER_TOOLTIP_HTML_LARMKOORDINAT": "Endast en larmkoordinat",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_DRIVNINGSPUNKTER_FRAN_KONTRAKT": "Hämta drivningspunkter från kontrakt",
    "PLANERA_ARBETSORDER_DETAIL_HANTERA_ATGARDER": "Hantera åtgärder",
    "PLANERA_ARBETSORDER_DETAIL_M3SK": "m3sk",
    "PLANERA_ARBETSORDER_DETAIL_MASKINLAG": "Maskinlag",
    "PLANERA_ARBETSORDER_DETAIL_MASKINLAG_NAVIGATE_TO_MASKINLAG": "Lägg till maskinlag",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT": "Produkt",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_FILTRERA_URVAL": "Filtrera urval",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_FILTRERA_PRODUKTIONSMAL": "Visa endast handelssortiment med produktionsmål",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_INAKTIV": "INAKTIV",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL": "Produktionsmall",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTVAL": "Produktval",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTVAL_BORTTAG_PRODUKT_KVANTITET": "Du tar nu bort en produkt: {{produktNamn}} som har kvantitet {{produktKvantitet}}. Om du vill behålla kvantiteten måste du manuellt justera in den på en annan produkt.",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_INGA_MALLAR": "Du har inte skapat några produktionsmallar. När du har valt handelssortiment, produkter och PIN under fliken produktval kan du välja att skapa en produktionsmall.",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_HEADER": "Ta bort produktionsmall?",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_TEXT": "Vill du verkligen ta bort produktionsmallen?",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_SKAPAD": "Produktionsmallen skapades",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_DOP_MALL": "Döp mall",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_SKAPA_NY_PRODUKTIONSMALL": "Skapa ny produktionsmall",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_SKAPA_PRODUKTIONSMALL": "Skapa produktionsmall",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_ANVAND_MALL": "Använd mall",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_PRODUKTIONSMALL_REDIGERA": "Redigera produktionsmallar",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKTIONSDATUM": "Produktionsdatum",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKTIONSDATUM_HAMTA_FORESLAGET_PRODUKTIONSDATUM": "Hämta föreslaget produktionsdatum",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKTIONSMAL_VISA_HANDELSSORTIMENTSGRUPP": "Visa handelssortimentsgrupp",
    "PLANERA_ARBETSORDER_DETAIL_REMOVE_PRODUKTGRUPP": "Ta bort produktgrupp",
    "PLANERA_ARBETSORDER_DETAIL_VIRKESORDER": "Virkesorder",
    "PLANERA_ARBETSORDER_DETAIL_SLUTDATUM": "Slutdatum",
    "PLANERA_ARBETSORDER_DETAIL_STARTDATUM": "Startdatum",
    "PLANERA_ARBETSORDER_DETAIL_TAB_ANTECKNINGAR": "Anteckningar",
    "PLANERA_ARBETSORDER_DETAIL_TAB_DESTINERING": "Destinering",
    "PLANERA_ARBETSORDER_DETAIL_TAB_DESTINERING_TRANSPORTTIDSPAN": "Totalt transporttidspan",
    "PLANERA_ARBETSORDER_DETAIL_TAB_DETALJER": "Detaljer",
    "PLANERA_ARBETSORDER_DETAIL_TAB_SAMMANFATTNING": "Sammanfattning",
    "PLANERA_ARBETSORDER_DETAIL_TAB_UTBYTESBERAKNING": "Utbytesberäkning",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA": "Simulera",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_HANDELSSORTIMENT_FRAN_KONTRAKT": "Hämta val och volymer från kontrakt",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_HANDELSSORTIMENT_FRAN_KONTRAKT_SENAST": "Senast hämtat kl {{franKontraktSenastHamtat}}",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_HANDELSSORTIMENT_TITLE": "Vill du hämta handelssortiment från virkesköpskontraktet?",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_HANDELSSORTIMENT_MESSAGE": "Befintliga val av handelssortiment, produkter och produktinstruktioner i Produkt tas bort.",
    "PLANERA_ARBETSORDER_DETAIL_KOPIERA_HANDELSSORTIMENT_CONFIRMBUTTON": "Ja, ersätt valen",
    "PLANERA_ARBETSORDER_DETAIL_RENSA_HANDELSSORTIMENT_TITLE": "Vill du rensa val av produkt?",
    "PLANERA_ARBETSORDER_DETAIL_RENSA_HANDELSSORTIMENT_MESSAGE": "Befintliga val av handelssortiment, produkter och produktinstruktioner i Produkt tas bort.",
    "PLANERA_ARBETSORDER_DETAIL_RENSA_HANDELSSORTIMENT_CONFIRMBUTTON": "Ja, rensa val",
    "PLANERA_ARBETSORDER_DETAIL_RENSA_VAL": "Rensa val",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_ANDRA_TILL": "Ändra till",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_VAL_FOR_ARBETSORDER": "Val för arbetsorder",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_VALDA_HS": "Handelssortiment",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_VOLYM": "Volym",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_PUID": "PIN",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_PRODUKTINSTRUKTION_TOOLTIP_TRADSLAG": "Trädslag",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_PRODUKTINSTRUKTION_TOOLTIP_NAMN": "Namn",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_PRODUKTINSTRUKTION_TOOLTIP_PUID": "PUID",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTESSIMULERA_INGA_PRODUKTER_VALDA": "Använd produktionsmallar eller produktval för att produktsätta arbetsordern",
    "PLANERA_ARBETSORDER_DETAIL_TILLBAKA_TILL_LISTA": "Tillbaka till lista",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERING_INFO_SENAST_ANDRAD": "Senast ändrad {{destineringSenastAndrad}}",
    "PLANERA_ARBETSORDER_DETAIL_DESTINERING_INFO_BESKRIVNING": "Baserat på kundorderrader med valda handelssortiment mellan",
    "PLANERA_ARBETSORDER_DETAIL_ARBETSORDERNAMN_LANGD": "Arbetsorderns namn kan inte överstiga 30 tecken",
    "PLANERA_ARBETSORDER_DETAIL_ARBETSORDERUPPDRAG": "Uppdrag får endast bestå av en siffra eller bokstav",
    "PLANERA_ARBETSORDER_DETAIL_ARBETSORDERVIRKETMARKT": "Virket märkt kan inte överstiga 10 tecken",
    "PLANERA_ARBETSORDER_DETAIL_UTBYTES_SIMULERING_INFO_SENAST_ANDRAD": "Senast ändrad {{dateUtbytesSimuleringDone}}",
    "PLANERA_ARBETSORDER_DETAIL_PRODUKT_RUNDVIRKE_EJ_SIMULERAT": "Simulera rundvirkesarbetsordern för att produktsätta.",
    "PLANERA_ARBETSORDER_GANTT_PERIOD": "Schemats startdatum",
    "PLANERA_ARBETSORDER_HEADER": "Arbetsorder",
    "PLANERA_ARBETSORDER_HEADER_ATGARDER": "åtgärder",
    "PLANERA_ARBETSORDER_HEADER_BILVAG": "Väg",
    "PLANERA_ARBETSORDER_HEADER_B-MAV": "B-mav",
    "PLANERA_ARBETSORDER_HEADER_GRANTIMMER": "GT",
    "PLANERA_ARBETSORDER_HEADER_KLENTIMMER_GRAN": "kGT",
    "PLANERA_ARBETSORDER_HEADER_KLENTIMMER_TALL": "kTT",
    "PLANERA_ARBETSORDER_HEADER_L-MAV": "L-mav",
    "PLANERA_ARBETSORDER_HEADER_TALL": "T",
    "PLANERA_ARBETSORDER_HEADER_GRAN": "G",
    "PLANERA_ARBETSORDER_HEADER_LOV": "L",
    "PLANERA_ARBETSORDER_HEADER_CONTORTA": "C",
    "PLANERA_ARBETSORDER_HEADER_M3FUB": "m3f",
    "PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG": "Skog",
    "PLANERA_ARBETSORDER_HEADER_MEDELSTAM": "Medelstam",
    "PLANERA_ARBETSORDER_HEADER_TALLTIMMER": "TT",
    "PLANERA_ARBETSORDER_HEADER_TOTAL": "Total",
    "PLANERA_ARBETSORDER_LEVERANSVIRKE_HAMTA_PRODUKTIONSDATUM": "Hämta f. prod.datum",
    "PLANERA_ARBETSORDER_LIST_ARBETSORDRAR": "Arbetsorder",
    "PLANERA_ARBETSORDER_LIST_COLLAPSE_LIST": "Dölj",
    "PLANERA_ARBETSORDER_LIST_VISA_ENBART_VALDA": "Visa enbart valda",
    "PLANERA_ARBETSORDER_TAB_KARTA": "Karta",
    "PLANERA_ARBETSORDER_TAB_SCHEMA": "Schema",
    "PLANERA_ARBETSORDER_TAB_MAL_PLAN": "Mål & plan",
    "PLANERA_ARBETSORDER_DETAIL_HANDELSSORTIMENT_SAKNAR_PRODUKTIONSMAL": "Kontrakterade handelssortiment visas alltid.",
    "PLANERA_KARTA_RITA_MARKERA": "Markera med lasso",
    "PLANERA_KARTA_RITA_AVMARKERA": "Avmarkera",
    "PLANERA_MAP_EXTENT_SELECTOR": "Kartutsnitt",
    "PLANERA_MAP_MEASURE": "Mät",
    "PLANERA_MAP_MEASURE_TITLE": "Mät i kartan",
    "PLANERA_DETAIL_SEARCH_HEADER": "Sök arbetsorder",
    "PLANERA_DETAIL_AVVERKNINGSGRUPP": "Avverkningsgrupp",
    "PLANERA_DETAIL_TILLGANGLIGHET": "Tillgänglighet",
    "PLANERA_DETAIL_BARIGHET_BILVAG": "Väg",
    "PLANERA_DETAIL_BARIGHET_SKOG": "Skog",
    "PLANERA_DETAIL_FOM": "Från och med",
    "PLANERA_DETAIL_GEOGRAFI": "Geografi",
    "PLANERA_DETAIL_GROT_RUNDVIRKE": "Rundvirke",
    "PLANERA_DETAIL_GROT_GROTSKOTNING": "Grotskotning",
    "PLANERA_DETAIL_GROT": "Grot",
    "PLANERA_DETAIL_GROT_RV_SKORDAD": "Grotskotning<br/> RV Skördad",
    "PLANERA_DETAIL_GROT_GROTANPASSAD": "Visa endast grotanpassat rundvirke",
    "PLANERA_DETAIL_GROT_RV_GROTANPASSAD": "Grotanpassad",
    "PLANERA_DETAIL_GROT_ALL": "Alla",
    "PLANERA_DETAIL_GROT_NO": "Nej",
    "PLANERA_DETAIL_GROT_YES": "Ja",
    "PLANERA_DETAIL_GROTANPASSNING_YES": "Ja",
    "PLANERA_DETAIL_GROTANPASSNING_NO": "Nej",
    "PLANERA_DETAIL_GROTANPASSNING_ALL": "Alla",
    "PLANERA_DETAIL_RV_SKORDNINGSDATUM": "RV Skördningsdatum",
    "PLANERA_DETAIL_HANDELSSORTIMENT": "Handelssortiment",
    "PLANERA_DETAIL_INVALID_VOLYM": "Volym saknas",
    "PLANERA_DETAIL_MASKINLAG": "Maskinlag",
    "PLANERA_DETAIL_MEDELSTAM_M3FUB": "Medelstam m3f",
    "PLANERA_DETAIL_MEDELSTAM_MIN": "Min",
    "PLANERA_DETAIL_MEDELSTAM_MAX": "Max",
    "PLANERA_DETAIL_NAMNBETECKNING": "Namn/beteckning",
    "PLANERA_DETAIL_NAMNBETECKNINGATGARD": "Namn/beteckning/åtgärd",
    "PLANERA_DETAIL_PERIOD": "Planerad period",
    "PLANERA_DETAIL_PERIOD_BUTTON": "Period",
    "PLANERA_DETAIL_PRODUKTGRUPP": "Produktgrupp",
    "PLANERA_DETAIL_PRODUKTGRUPP_MINVOLYM": "Minst volym",
    "PLANERA_DETAIL_PRODUKTIONSMAL_HAMTAT": "Hämtat",
    "PLANERA_DETAIL_PRODUKTIONSMAL_MAL": "Mål",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PERIOD": "Period",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PERIODSATT": "Periodsatt",
    "PLANERA_DETAIL_PRODUKTIONSMAL_LEVERANSVIRKE": "Leveransvirke",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PLAN_HEADER": "Produktionsmål & plan",
    "PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_MAL": "Produktionsmålet baseras på försörjningsrader, lagermål och ingående lager.",
    "PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_PRODUKTSATT": "Total volym av arbetsordrar med utbytessimulering. Arbetsordrarna är antingen periodsatta eller maskinlagda.",
    "PLANERA_DETAIL_PRODUKTIONSMAL_POPOVER_HELP_LEVERANSVIRKE": "Total volym av arbetsordrar med åtgärder från leveransvirkeskontrakt. Leveransvirke räknas inte in som virkesköp i staplarna för periodsatt, produktsatt och klara, utan särredovisas i denna stapel.",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PRODUKTIONSOMRADE": "Produktionsområde",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PRODUKTIONSOMRADE_PERIOD_AVDELARE": " i ",
    "PLANERA_DETAIL_PRODUKTIONSMAL_PRODUKTSATT": "Produktsatt",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_TOTALT_MAL": "{{ totalKvantitet }} totalt",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_TOTALT_PLAN": "{{ totalKvantitet }} totalt varav {{ virkeskopKvantitet }} är virkesköp",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_LEVERANSVIRKE": "{{ totalKvantitet }} totalt",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_EGEN_SKOG": "{{ egenSkogKvantitet }} egen skog",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_PA_MANAD": "{{ manadKvantitet }} på månad",
    "PLANERA_DETAIL_PRODUKTIONSMAL_TOOLTIP_PA_MASKINLAG": "{{ maskinlagKvantitet }} på maskinlag",
    "PLANERA_DETAIL_PRODUKTIONSMAL_WARNING_NEGATIVE_GOAL": "&#x26A0; {{ negativeGoals }} har obalans mellan kundorder och lager, bör ej produceras.",
    "PLANERA_DETAIL_PRODUKTIONSMAL_VISAR": "Visar",
    "PLANERA_DETAIL_PRODUKTIONSOMRADER_ERROR": "Du måste ange ett produktionsområde",
    "PLANERA_DETAIL_ANSKAFFNINGSFORM": "Anskaffningsform",
    "PLANERA_DETAIL_TOM": "Till och med",
    "PLANERA_DETAIL_VIRKESKOP": "Virkesköp",
    "PLANERA_DETAIL_VIRKESKOP_ROTPOST": "U2 Rotpost",
    "PLANERA_DETAIL_VIRKESKOP_FAST_KOSTNAD": "U4 AU Fast kostnad",
    "PLANERA_DETAIL_VIRKESKOP_SJAlVKOSTNAD": "U5 AU Självkostnad",
    "PLANERA_DETAIL_VIRKESKOP_LEVERANSROTKOP": "U6 Leveransrotköp",
    "PLANERA_DETAIL_VIRKESKOP_AFFARSFORM": "Affärsform",
    "PLANERA_DETAIL_VIRKESKOP_VIRKESKOPARE": "Virkesköpare",
    "PLANERA_DETAIL_VIRKESKOP_KONTRAKTSNUMMER": "Kontraktsnummer",
    "PLANERA_DETAIL_STATUS": "Status",
    "PLANERA_DETAIL_STATUS_PLANERINGSSTATUS": "Planeringsstatus",
    "PLANERA_DETAIL_STATUS_PLANERINGSSTATUS_UNDER_PLANERING": "Under planering",
    "PLANERA_DETAIL_STATUS_PLANERINGSSTATUS_FARDIGPLANERAD": "Färdigplanerad",
    "PLANERA_DETAIL_STATUS_PLANERINGSSTATUS_TILLGANGLIG": "Tillgänglig",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS": "Produktionsstatus",
    "PLANERA_DETAIL_PRODUKTIONSPLANERINGSSTATUS": "Produktionsplaneringsstatus",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_REDOFORPRODUKTION": "Redo för produktion",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_MASKINLAG_EXISTS": "Valt maskinlag",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_MASKINLAG_NOTEXISTS": "Ej valt maskinlag",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_PRODUKTER_EXISTS": "Produktsatt",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_PRODUKTER_NOTEXISTS": "Ej produktsatt",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_DESTINERAD_EXISTS": "Destinerad",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_DESTINERAD_NOTEXISTS": "Ej destinerad",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_DRIVNINGSPUNKTER_EXISTS": "Godkända drivningspunkter",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_DRIVNINGSPUNKTER_NOTEXISTS": "Ej godkända drivningspunkter",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_PRODUKTION_PAGAR": "Produktion pågår",
    "PLANERA_DETAIL_PRODUKTIONSSTATUS_PRODUKTION_GODKAND": "Produktion godkänd",
    "PLANERA_DETAIL_SKOGLIGDATA": "Skoglig data",
    "PLANERA_DETAIL_SKOGLIGDATA_SKOG": "Skog",
    "PLANERA_DETAIL_SKOGLIGDATA_VAG": "Väg",
    "PLANERA_DETAIL_SKORDNINGSDATUM": "Skördningsdatum",
    "PLANERA_DETAIL_HAMTA_DRIVNINGSPUNKTER_SAVE_MODAL_BODY": "Om du hämtar drivningspunkter utan att spara först kommer du att förlora dina ändringar.",
    "PLANERA_DETAIL_HAMTA_DRIVNINGSPUNKTER_SAVE_MODAL_SAVEBUTTON": "Spara och hämta drivningspunkter",
    "PLANERA_DETAIL_HAMTA_DRIVNINGSPUNKTER_SAVE_MODAL_TITLE": "Vill du spara dina ändringar innan du hämtar drivningspunkter?",
    "PLANERA_HEADER_OLD": "Planera (Gamla)",
    "PLANERA_HEADER": "Planera",
    "PLANERA_POPUP_AVVERKNINGSGRUPP": "Avverkningsgrupp",
    "PLANERA_POPUP_ATGARDSTYP": "Åtgärdstyp",
    "PLANERA_POPUP_DATUM": "Datum",
    "PLANERA_POPUP_MEDELSTAM": "Medelstam",
    "PLANERA_POPUP_SAMRAD": "Samråd",
    "PLANERA_POPUP_PLANERINGSSTATUS": "Planeringsstatus",
    "PLANERA_POPUP_PLANERADSKOTNING": "Planerad skotning",
    "PLANERA_POPUP_VOLYM": "Volym",
    "PLANERA_ARBETSORDER_DEFAULT_CONCURRENCY_MESSAGE_TITLE": "Arbetsordern har uppdaterats",
    "PLANERA_ARBETSORDER_DEFAULT_CONCURRENCY_MESSAGE": "Arbetsordern har uppdaterats och behöver laddas om innan eventuella ändringar kan sparas",
    "PRODUKT_DETAIL_AKTIV": "Aktiv",
    "PRODUKT_DETAIL_BASDATA": "Basdata",
    "PRODUKT_DETAIL_BASDATA_FORDELNINGSMATRISSKPAD_INFO": "Fördelningsmatrisen skapad på fliken <strong>Fördelningsmatris</strong>",
    "PRODUKT_DETAIL_BASDATAOCHKUNSPECIFIKA_INFO": "Lägg till diameter och längdvärden på flik <strong>Basdata och kundspecifika krav</strong> för att skapa matrisen",
    "PRODUKT_DETAIL_BESKRIVNING": "Beskrivning",
    "PRODUKT_DETAIL_BETECKNING": "Beteckning",
    "PRODUKT_DETAIL_BUTTON_LABEL_KOPIERA": "Kopiera",
    "PRODUKT_DETAIL_BUTTON_LABEL_KOPIERAPRODUKT_MED_SPEC": "Produkt med vald Produktspecifikation",
    "PRODUKT_DETAIL_BUTTON_LABEL_KOPIERAPRODUKT_UTAN_SPEC": "Produkt utan Produktspecifikation",
    "PRODUKT_DETAIL_BUTTON_LABEL_KOPIERAPRODUKTSPECIFIKATION": "Vald Produktspecifikation",
    "PRODUKT_DETAIL_DELETE_PROMPT_HEADER": "Radera produkt",
    "PRODUKT_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av produkt",
    "PRODUKT_DETAIL_DIAMETER_HELP_TEXT": "Mellan 0,1 och 1 000. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETER_HELP_TTILE": "Diameter för rot",
    "PRODUKT_DETAIL_DIAMETER_MAX_HELP_TEXT": "Mellan 0,1 och 1 000 som är större än Min-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETER_MAX_HELP_TITLE": "Diameter max",
    "PRODUKT_DETAIL_DIAMETER_MAX_VALIDERING": "Du måste ange ett värde mellan 0,1 och 1 000 som är större än Min-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETER_MIN_HELP_TEXT": "Mellan 0,1 och 1 000 som är mindre än Max-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETER_MIN_HELP_TITLE": "Diameter min",
    "PRODUKT_DETAIL_DIAMETER_MIN_VALIDERING": "Du måste ange ett värde mellan 0,1 och 1 000 som är mindre än Max-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETER_ROT": "Rot",
    "PRODUKT_DETAIL_DIAMETER_TOPP": "Topp",
    "PRODUKT_DETAIL_DIAMETER_VALIDERING": "Du måste ange ett värde mellan 0,1 och 1 000. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_DIAMETERFORDELNING": "Diameterfördelning",
    "PRODUKT_DETAIL_DIAMETERFORDELNING_LARM_POPOVER_HEAD": "Diameterfördelning",
    "PRODUKT_DETAIL_DIAMETERFORDELNING_LARM_POPOVER_TEXT": "Larm inträffar då Diameter hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_DIAMETERFORDELNING_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_DIAMETERFORDELNING_VARNING_POPOVER_HEAD": "Diameterfördelning",
    "PRODUKT_DETAIL_DIAMETERFORDELNING_VARNING_POPOVER_TEXT": "Varning inträffar då Diameter hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_DIAMETERINTERVALL": "Diameter i cm",
    "PRODUKT_DETAIL_EDITERA": "Produkt",
    "PRODUKT_DETAIL_FLISSTORLEK_ONSKAD": "Önskad flisstorlek (cm)",
    "PRODUKT_DETAIL_FLISSTORLEK_ONSKAD_HELP_TEXT": "Mellan 0,1 och 30. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_FLISSTORLEK_ONSKAD_HELP_TITLE": "Önskad flisstorlek (cm)",
    "PRODUKT_DETAIL_FLISSTORLEK_ONSKAD_VALIDERING": "Du måste ange ett värde mellan 0,1 och 30. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL": "Flisstorlekandel",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL_LARM_POPOVER_HEAD": "Flisstorlekandel",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL_LARM_POPOVER_TEXT": "Larm inträffar då Flisstorlekandel hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL_VARNING_POPOVER_HEAD": "Flisstorlekandel",
    "PRODUKT_DETAIL_FLISSTORLEKANDEL_VARNING_POPOVER_TEXT": "Varning inträffar då Flisstorlekandel hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_FORDELNINGSGRAD": "Fördelningsgrad",
    "PRODUKT_DETAIL_FORDELNINGSGRAD_LARM_POPOVER_HEAD": "Fördelningsgrad",
    "PRODUKT_DETAIL_FORDELNINGSGRAD_LARM_POPOVER_TEXT": "Larm inträffar då Fördelningsgrad hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_FORDELNINGSGRAD_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_FORDELNINGSGRAD_VARNING_POPOVER_HEAD": "Fördelningsgrad",
    "PRODUKT_DETAIL_FORDELNINGSGRAD_VARNING_POPOVER_TEXT": "Varning inträffar då Fördelningsgrad hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_FUKTHALT": "Fukthalt (%)",
    "PRODUKT_DETAIL_FUKTHALT_HELP_TEXT": "Mellan 0 och 100",
    "PRODUKT_DETAIL_FUKTHALT_HELP_TITLE": "Fukthalt (%)",
    "PRODUKT_DETAIL_FUKTHALT_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_FUKTHALTANDEL": "Fukthaltandel",
    "PRODUKT_DETAIL_FUKTHALTANDEL_LARM_POPOVER_HEAD": "Fukthaltandel",
    "PRODUKT_DETAIL_FUKTHALTANDEL_LARM_POPOVER_TEXT": "Larm inträffar då Fukthaltandel hamnar ÖVER angivet värde",
    "PRODUKT_DETAIL_FUKTHALTANDEL_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_FUKTHALTANDEL_VARNING_POPOVER_HEAD": "Fukthaltandel",
    "PRODUKT_DETAIL_FUKTHALTANDEL_VARNING_POPOVER_TEXT": "Varning inträffar då Fukthaltandel hamnar ÖVER angivet värde",
    "PRODUKT_DETAIL_GILTIGHET_DATUM_VALIDERING": "Du måste ange ett giltigt datum",
    "PRODUKT_DETAIL_GILTIGHET_FROM": "Giltig fr.o.m.",
    "PRODUKT_DETAIL_GILTIGHET_FROM_TOOLTIP": "Ange det datum när kunden först kan ta emot en produkt med angiven specifikation",
    "PRODUKT_DETAIL_GILTIGHET_TOM": "Giltig t.o.m.",
    "PRODUKT_DETAIL_KUNDSPECIFIKAKRAV": "Kundspecifika krav",
    "PRODUKT_DETAIL_LANGDFORDELNING": "Längdfördelning",
    "PRODUKT_DETAIL_LANGDFORDELNING_LARM_POPOVER_HEAD": "Längdfördelning",
    "PRODUKT_DETAIL_LANGDFORDELNING_LARM_POPOVER_TEXT": "Larm inträffar då längdfördelningen hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_LANGDFORDELNING_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_LANGDFORDELNING_VARNING_POPOVER_HEAD": "Längdfördelning",
    "PRODUKT_DETAIL_LANGDFORDELNING_VARNING_POPOVER_TEXT": "Varning inträffar då längdfördelningen hamnar UNDER angivet värde",
    "PRODUKT_DETAIL_LANGDGRANS_MAX_HELP_TEXT": "Mellan 1 och 5 000 som är större än Min-värdet. Inga decimaler tillåtna.",
    "PRODUKT_DETAIL_LANGDGRANS_MAX_HELP_TITLE": "Längdgräns max",
    "PRODUKT_DETAIL_LANGDGRANS_MAX_VALIDERING": "Du måste ange ett värde mellan 1 och 5 000 som är större än Min-värdet. Inga decimaler tillåtna.",
    "PRODUKT_DETAIL_LANGDGRANS_MIN_HELP_TEXT": "Mellan 1 och 5 000 som är mindre än Max-värdet. Inga decimaler tillåtna.",
    "PRODUKT_DETAIL_LANGDGRANS_MIN_HELP_TITLE": "Längdgräns min",
    "PRODUKT_DETAIL_LANGDGRANS_MIN_VALIDERING": "Du måste ange ett värde mellan 1 och 5 000 som är mindre än Max-värdet. Inga decimaler tillåtna.",
    "PRODUKT_DETAIL_LANGDGRANSER": "Längder i cm",
    "PRODUKT_DETAIL_LANGDMODUL_HELP_TEXT": "Värde mellan min- och max-längd. Inga decimaler tillåtna.",
    "PRODUKT_DETAIL_LANGDMODUL_HELP_TITLE": "Längdmodul",
    "PRODUKT_DETAIL_LANGDMODULER_ERROR_FINNSREDAN": "Längdmodul finns redan",
    "PRODUKT_DETAIL_LANGDMODULER_ERROR_LANGDGRANSER": "Längd hamnar ÖVER/UNDER angivet längdgränser",
    "PRODUKT_DETAIL_LANGDMODULER_GENERERING": "Skapa längdmoduler",
    "PRODUKT_DETAIL_LANGDMODULER_INGA_LANGDMODULER": "Inga längdmoduler",
    "PRODUKT_DETAIL_LANGDMODULER_INTERVAL": "Längdintervall",
    "PRODUKT_DETAIL_LANGDMODULER_INTERVAL_TOOLTIP": "Ange vilket intervall som ska användas för att generera upp ett antal längdmoduler utifrån min-max-längdgränser",
    "PRODUKT_DETAIL_LANGDMODULER_LANGD": "Längdmoduler",
    "PRODUKT_DETAIL_LANGDMODULER_LANGMODULER": "Längder",
    "PRODUKT_DETAIL_LANGDMODULER_MANUELLTKAP": "Manuellt kap",
    "PRODUKT_DETAIL_LANGDMODULER_MANUELLTKAP_INFO": "Ej önskad längd - Blå markering",
    "PRODUKT_DETAIL_LARM": "Larm (%)",
    "PRODUKT_DETAIL_LOGG": "Logg",
    "PRODUKT_DETAIL_MANUELLA_KAP": "Manuella kap",
    "PRODUKT_DETAIL_MANUELLA_KAP_LARM__POPOVER_TEXT": "Larm inträffar då Manuellt kap hamnar ÖVER angivet värde",
    "PRODUKT_DETAIL_MANUELLA_KAP_LARM_POPOVER_HEAD": "Manuella kap",
    "PRODUKT_DETAIL_MANUELLA_KAP_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_MANUELLA_KAP_VARNING__POPOVER_HEAD": "Manuella kap",
    "PRODUKT_DETAIL_MANUELLA_KAP_VARNING__POPOVER_TEXT": "Varning inträffar då Manuellt kap hamnar ÖVER angivet värde",
    "PRODUKT_DETAIL_MATINSTRUKTION": "Mätinstruktion",
    "PRODUKT_DETAIL_MATINSTRUKTION_TOOLTIP": "Ange namn och länk till den eller de mätinstruktioner som ska användas när produkten mäts på mätplatsen",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION": "Mätningsinstruktion",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_DELETE_PROMPT_HEADER": "Vill du ta bort kopplingen till mätningsinstruktion?",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_DELETE_PROMPT_TEXT": "Kopplingen till mätningsinstruktion kommer att tas bort från denna produkt",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_INTELAGTSTILL": "Länk till mätningsinstruktion har inte lagts till",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_LADESTILL": "Lades till",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_LANK": "Länk",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_LANKANY": "Länka till ny mätningsinstruktion",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_LANKTILL": "Länk till",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_LANKTILL_TOOLTIP": "Du kan länka till en mätningsinstruktion på virkesmätningsföreningens webbplats eller lägga upp på sharepoint och länka dit.",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_OGILTIGT_LINK": "Ogiltigt länk Ex: http://www.sveaskog.se",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_TABORT": "Ta bort",
    "PRODUKT_DETAIL_MATNINGSINSTRUKTION_TEXT": "Text som ska visas",
    "PRODUKT_DETAIL_MEDDELLANGD_OPTIMERAD": "Optimerad medellängd (cm)",
    "PRODUKT_DETAIL_MEDDELLANGD_OPTIMERAD_HELP_TEXT": "Mellan 0,1 och 5 000. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_MEDDELLANGD_OPTIMERAD_HELP_TITLE": "Optimerad medellängd (cm)",
    "PRODUKT_DETAIL_MEDDELLANGD_OPTIMERAD_VALIDERING": "Du måste ange ett värde mellan 0,1 och 5 000. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_MODULTRAFF": "Modulträff (cm)",
    "PRODUKT_DETAIL_MODULTRAFF_MAX_HELP_TEXT": "Mellan -50,0 och 50,0. Endast en decimal är tillåten",
    "PRODUKT_DETAIL_MODULTRAFF_MAX_HELP_TITLE": "Modulträff max",
    "PRODUKT_DETAIL_MODULTRAFF_MAX_VALIDERING": "Du måste ange ett värde mellan -50,0 och 50,0 som är större än Min-värdet",
    "PRODUKT_DETAIL_MODULTRAFF_MIN_HELP_TEXT": "Mellan -50,0 och 50,0. Endast en decimal är tillåten",
    "PRODUKT_DETAIL_MODULTRAFF_MIN_HELP_TITLE": "Modulträff min",
    "PRODUKT_DETAIL_MODULTRAFF_MIN_VALIDERING": "Du måste ange ett värde mellan -50,0 och 50,0 som är mindre än Max-värdet",
    "PRODUKT_DETAIL_NAMN": "Namn",
    "PRODUKT_DETAIL_NAMN_VALIDATION": "Du måste ange ett produktnamn",
    "PRODUKT_DETAIL_OVERMAL": "Övermål för längder i cm",
    "PRODUKT_DETAIL_OVERMAL_MAX_HELP_TEXT": "Mellan 0,1 och 50. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_OVERMAL_MAX_HELP_TITLE": "Övermål max",
    "PRODUKT_DETAIL_OVERMAL_MAX_VALIDERING": "Du måste ange ett värde mellan 0,1 och 50 som är större än Min-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_OVERMAL_MIN_HELP_TEXT": "Mellan 0,1 och 50. Endast en decimal är tillåten",
    "PRODUKT_DETAIL_OVERMAL_MIN_HELP_TITLE": "Övermål min",
    "PRODUKT_DETAIL_OVERMAL_MIN_VALIDERING": "Du måste ange ett värde mellan 0,1 och 50 som är mindre än Max-värdet. Endast en decimal är tillåten.",
    "PRODUKT_DETAIL_OVERMAL_TOOLTIP": "Ange hur många centimeter längre kunden vill ha alla stockar för att vara säker på att den inte blir för kort för modulgränsen",
    "PRODUKT_DETAIL_PRODUKTGRUPP": "Produktgrupp",
    "PRODUKT_DETAIL_PRODUKTGRUPP_VALIDATION": "Du måste ange en produktgrupp",
    "PRODUKT_DETAIL_PRODUKTOPERATION": "Produktoperation",
    "PRODUKT_DETAIL_PRODUKTSPECIFIKATION": "Produktspecifikation",
    "PRODUKT_DETAIL_ROTANDEL_MAX": "Maximal rötandel (%)",
    "PRODUKT_DETAIL_ROTANDEL_MAX_HELP_TEXT": "Mellan 0 och 100",
    "PRODUKT_DETAIL_ROTANDEL_MAX_HELP_TITLE": "Maximal rötandel (%)",
    "PRODUKT_DETAIL_ROTANDEL_MAX_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_SARSKILDINFO": "Särskild information till maskinlag",
    "PRODUKT_DETAIL_SKAPA_FORDELNINGSMATRIS": "Skapa fördelningsmatris",
    "PRODUKT_DETAIL_SKAPA_NY": "Skapa ny produkt",
    "PRODUKT_DETAIL_SKAPAD_AV": "Skapad av",
    "PRODUKT_DETAIL_SORTIMENT": "Sortimentskod",
    "PRODUKT_DETAIL_SORTIMENT_VALIDATION": "Du måste ange minst en sortimentskod",
    "PRODUKT_DETAIL_TAB_BAS": "Basdata och kundspecifika krav",
    "PRODUKT_DETAIL_TAB_FORDELNINGSMATRIS": "Fördelningsmatris",
    "PRODUKT_DETAIL_TAB_GILTIGHET": "Giltighetstid",
    "PRODUKT_DETAIL_TAB_PRODUKTINSTRUKTIONER": "Produktinstruktioner",
    "PRODUKT_DETAIL_TAB_UPPFOLJNING": "Uppföljning",
    "PRODUKT_DETAIL_TRADDEL": "Träddel",
    "PRODUKT_DETAIL_TRADDEL_ALLA_STOCK": "Alla - stock",
    "PRODUKT_DETAIL_TRADDEL_ENERGISORTIMENT": "Energisortiment",
    "PRODUKT_DETAIL_TRADDEL_MELLAN_TOP": "Mellan/topp",
    "PRODUKT_DETAIL_TRADDEL_ROT": "Rot",
    "PRODUKT_DETAIL_TRADSLAG": "Trädslag",
    "PRODUKT_DETAIL_VARNING": "Varning (%)",
    "PRODUKT_DETAIL_VARNING_LARMNIVA": "Varnings- och larmnivåer",
    "PRODUKT_DETAIL_VRAKANDEL": "Vrakandel",
    "PRODUKT_DETAIL_VRAKANDEL_LARM_POPOVER_HEAD": "Vrakandel",
    "PRODUKT_DETAIL_VRAKANDEL_LARM_POPOVER_TEXT": "Larm inträffar då Vrakandel hamnar ÖVER angivet värde",
    "PRODUKT_DETAIL_VRAKANDEL_VALIDERING": "Du måste ange ett värde mellan 0 och 100",
    "PRODUKT_DETAIL_VRAKANDEL_VARNING_POPOVER_HEAD": "Vrakandel",
    "PRODUKT_DETAIL_VRAKANDEL_VARNING_POPOVER_TEXT": "Varning inträffar då Vrak hamnar ÖVER angivet värde",
    "PRODUKT_HEADER": "Produkt",
    "PRODUKT_SKAPA": "Skapa ny produkt",
    "PRODUKT_LIST_AKTIV": "Aktiv",
    "PRODUKT_LIST_BETECKNING": "Beteckning",
    "PRODUKT_LIST_GILTIG_FROM": "Giltig fr.o.m.",
    "PRODUKT_LIST_GILTIG_TOM": "Giltig t.o.m.",
    "PRODUKT_LIST_HANDELSSORTIMENT": "Handelssortiment",
    "PRODUKT_LIST_HEADER": "Produkt",
    "PRODUKT_LIST_NAMN": "Namn",
    "PRODUKT_LIST_PRODUKTGRUPP": "Produktgrupp",
    "PRODUKT_LIST_HANDELSSORTIMENTSKATEGORI": "Handelssortimentskategori",
    "PRODUKT_LIST_SOK": "Sök produkt",
    "PRODUKT_LIST_SORTIMENTSKOD": "Sortimentskod",
    "PRODUKT_LIST_TRADSLAG": "Trädslag",
    "PRODUKT_MATRIS_ADD_CHANGE_DIAMETER_ERROR": "Du måste ange ett värde mellan {{minDiameter}} och {{maxDiameter}} med en decimals noggrannhet som inte redan är registrerat.",
    "PRODUKT_MATRIS_ADD_CHANGE_DIAMETER_HELP_TEXT": "Ange ett värde mellan {{minDiameter}} och {{maxDiameter}} med en decimals noggrannhet som inte redan är registrerat.",
    "PRODUKT_MATRIS_ADD_CHANGE_LANGD_ERROR": "Du måste ange ett värde mellan {{minLangd}} och {{maxLangd}} som inte redan är registrerat.",
    "PRODUKT_MATRIS_ADD_CHANGE_LANGD_HELP_TEXT": "Ange ett värde mellan {{minLangd}} och {{maxLangd}} som inte redan är registrerat",
    "PRODUKT_MATRIS_ADD_DIAMETER": "Lägg till ny diameter",
    "PRODUKT_MATRIS_ADD_LANGD": "Lägg till ny längd",
    "PRODUKT_MATRIS_CHANGE_REMOVE_DIAMETER": "Ändra/Ta bort diameter",
    "PRODUKT_MATRIS_CHANGE_REMOVE_LANGD": "Ändra/Ta bort längd",
    "PRODUKT_MATRIS_CHANGE_TYP_HEADER": "Ändra fördelningstyp",
    "PRODUKT_MATRIS_CHANGE_TYP_TEXT": "Vill du ändra fördelningstyp? Observera att all tidigare lagrad data försvinner",
    "PRODUKT_MATRIS_DELETE_FORDELNING_HEADER": "Radera fördelningar",
    "PRODUKT_MATRIS_DELETE_FORDELNING_TEXT": "Vill du radera valda fördelningar?",
    "PRODUKT_MATRIS_DIAM_HEADER": "Diameterfördelning",
    "PRODUKT_MATRIS_DIAMLANGD_HEADER": "Längd/Diameter",
    "PRODUKT_MATRIS_LABEL_AXELBESKRIVNING": "↓ Längd / Diameter →",
    "PRODUKT_MATRIS_LABEL_DIAMETER": "Diameter",
    "PRODUKT_MATRIS_LABEL_LANGD": "Längd",
    "PRODUKT_MATRIS_LANGD_HEADER": "Längdfördelning",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_DELETE_PROMPT_HEADER": "Vill du ta bort kopplingen till produktinstruktionen?",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_DELETE_PROMPT_TEXT": "Kopplingen till produktinstruktionen kommer att tas bort från denna produkt.",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_HEADER": "Produktinstruktioner",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_LADDANEDPIN": "Ladda ned PIN-fil",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_MOTTAGNINGSPLATS": "Mottagningsplats i ABS",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_NAMN": "Namn",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_VERSION": "Version",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_SORTIMENT": "Sortiment i ABS",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_TABORTKOPPLING": "Ta bort koppling",
    "PRODUKT_PRODUKTINSTRUKTION_DETAIL_PUID": "Puid",
    "PRODUKT_PRODUKTINSTRUKTION_LIST_SOK": "Sök produktinstruktion",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_VERSION": "Version",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_LAGG_TILL": "Lägg till",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_MOTTAGNINGSPLATS": "Mottagningsplats i ABS",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_NAMN": "Namn",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_SORTIMENT": "Sortiment i ABS",
    "PRODUKT_PRODUKTINSTRUKTIONER_LIST_PUID": "Puid",
    "HANDELSSORTIMENTSGRUPP_HANDELSSORTIMENT_SELECTOR_PLACEHOLDER": "Välj handelssortimentsgrupp/handelssortiment",
    "PRODUKTION_HEADER": "Produktion",
    "PRODUKTIONSMAL_HEADER": "Produktionsmål",
    "PRODUKTIONSMAL_ROWHEADER_TYP_INGAENDE_LAGER": "Ingående lager",
    "PRODUKTIONSMAL_ROWHEADER_TYP_LAGERMAL": "Lagermål",
    "PRODUKTIONSMAL_ROWHEADER_TYP_ORDER": "Kundorder/Terminalorder",
    "PRODUKTIONSMAL_ROWHEADER_TYP_PRODUKTONSMAL": "Produktionsmål",
    "PRODUKTIONSMAL_SELECT_FRAN": "Fr.o.m.",
    "PRODUKTIONSMAL_SELECT_HANDELSSORTIMENTSGRUPP": "Handelssortimentsgrupp/Handelssortiment",
    "PRODUKTIONSMAL_SELECT_TILL": "T.o.m.",
    "PRODUKTIONSMAL_TABELL_HEADER": "Produktionsmål i m3f",
    "REGELVERK_VIOL3": "Regelverk VIOL3",
    "REGELVERK_FILTER": "Filter...",
    "REGELVERK_LIST_SST": "SST",
    "REGELVERK_LIST_EGENSKAPSKOD": "E",
    "REGELVERK_LIST_SDCSST": "SDC SST",
    "REGELVERK_LIST_SDCEGENSKAPSKOD": "SDC Egenskapskod",
    "REGELVERK_LIST_MOTTAGARE": "Mottagare *",
    "REGELVERK_LIST_AFFARSLEDKOD": "ALkod",
    "REGELVERK_LIST_AFFARSLEDKODTEXT": "Beskrivning",
    "REGELVERK_LIST_KONTRAKTLED2": "Kontrakt",
    "REGELVERK_LIST_KOPARELED2": "Köpare",
    "REGELVERK_LIST_SALJARELED2": "Säljare",
    "REGELVERK_LIST_KONTRAKTLED3": "Kontrakt",
    "REGELVERK_LIST_KOPARELED3": "Köpare",
    "REGELVERK_LIST_SALJARELED3": "Säljare",
    "REGELVERK_LIST_KONTRAKTLED4": "Kontrakt",
    "REGELVERK_LIST_KOPARELED4": "Köpare",
    "REGELVERK_LIST_SALJARELED4": "Säljare",
    "REGELVERK_LIST_KONTRAKTLED5": "Kontrakt",
    "REGELVERK_LIST_KOPARELED5": "Köpare",
    "REGELVERK_LIST_SALJARELED5": "Säljare",
    "REGELVERK_LIST_KONTRAKTLED6": "Kontrakt",
    "REGELVERK_LIST_KOPARELED6": "Köpare",
    "REGELVERK_LIST_SALJARELED6": "Säljare",
    "REGELVERK_LIST_ENERGIBERAKNINGNYCKEL": "EbNyckel",
    "REGELVERK_LIST_MATNINGSOMFATTNING": "Omf.",
    "REGELVERK_LIST_KOLLEKTIV": "Kollektiv",
    "REGELVERK_LIST_MATMETODA": "A",
    "REGELVERK_LIST_MATMETODB": "B",
    "REGELVERK_LIST_MATMETODC": "C",
    "REGELVERK_LIST_MATMETODD": "D",
    "REGELVERK_LIST_MATTSLAG": "Mslag",
    "REGELVERK_LIST_MATTSLAGAVTALAT": "Avtalat mslag",
    "REGELVERK_LIST_MATNINGSBESTALLNING": "Mätn best",
    "REGELVERK_LIST_MATPLATSTYP": "Mpl typ",
    "REGELVERK_LIST_FROMDATUM": "FromDatum *",
    "REGELVERK_LIST_TOMDATUM": "TomDatum",
    "REGELVERK_LIST_VIRKESMATNINGSFORENING": "VMF *",
    "REGELVERK_LIST_LAN_KOMMUN_DISTRIKT": "LKD",
    "REGELVERK_LIST_RUBRIK_LED2": "LED 2",
    "REGELVERK_LIST_RUBRIK_LED3": "LED 3",
    "REGELVERK_LIST_RUBRIK_LED4": "LED 4",
    "REGELVERK_LIST_RUBRIK_LED5": "LED 5",
    "REGELVERK_LIST_RUBRIK_LED6": "LED 6",
    "REGELVERK_LIST_RUBRIK_MATMETOD": "Mätmetod",
    "SCHEDULER_HEADER": "Schemaläggning",
    "SCHEMALAGGNING_LIST_TITLE": "Schemaläggning",
    "SCHEMALAGGNING_LIST_ENABLETIMER": "Uppdatera varje minut",
    "SCHEMALAGGNING_LIST_JOBBSTATUS": "Status",
    "SCHEMALAGGNING_LIST_JOBBNAMN": "Namn",
    "SCHEMALAGGNING_LIST_SENASTSLUT": "Senast körd",
    "SCHEMALAGGNING_LIST_SENASTVARAKTIGHET": "Varaktighet (sek)",
    "SCHEMALAGGNING_LIST_SENASTRESULTAT": "Senaste meddelande",
    "SCHEMALAGGNING_LIST_SENASTSTATUS": "Resultat",
    "SCHEMALAGGNING_LIST_NASTASTART": "Nästa körning",
    "SCHEMALAGGNING_LIST_SCHEMALAGG": "Schemalägg",
    "SCHEMALAGGNING_LIST_CONFIRM_TITLE": "Schemalägga?",
    "SCHEMALAGGNING_LIST_CONFIRM_QUESTION": "Är du säker på att du vill schemalägga",
    "SCHEMALAGGNING_LIST_CONFIRM_RESPONSE": "Jobb tillagt.",
    "SCHEMALAGGNING_DETAIL_TITLE": "Historik för",
    "SCHEMALAGGNING_DETAIL_STATUS": "Status",
    "SCHEMALAGGNING_DETAIL_START": "Start",
    "SCHEMALAGGNING_DETAIL_SLUT": "Slut",
    "SCHEMALAGGNING_DETAIL_VARAKTIGHET": "Varaktighet (sek)",
    "SCHEMALAGGNING_DETAIL_RESULTAT": "Meddelande",
    "REBUS_HEADER": "Rebus",
    "JOBB_HEADER": "Jobb",
    "SORTIMENT_DETAIL_AKTIV": "Aktiv",
    "SORTIMENT_DETAIL_EDITERA": "Sortiment",
    "SORTIMENT_DETAIL_ERROR_PRODUKTGRUPP": "Produktgrupp saknas",
    "SORTIMENT_DETAIL_HEADER": "Sortiment",
    "SORTIMENT_DETAIL_KOD": "Kod",
    "SORTIMENT_DETAIL_KOD_HELP_TEXT": "Mellan 3 till 4 tecken",
    "SORTIMENT_DETAIL_KOD_HELP_TITLE": "Sortimentkod",
    "SORTIMENT_DETAIL_KOD_VALIDATION": "Sortimentkod måste innehålla 3 till 4 tecken",
    "SORTIMENT_DETAIL_NAMN": "Namn",
    "SORTIMENT_DETAIL_PRODUKTGRUPP": "Produktgrupp",
    "SORTIMENT_DETAIL_SKAPA_NY": "Skapa nytt sortiment",
    "SORTIMENT_HEADER": "Sortiment",
    "CERTIFIKAT_HEADER": "Certifikat",
    "KONTRAKTSMIGRERING_HEADER": "Kontraktsmigrering",
    "SORTIMENT_LIST_AKTIV": "Aktiv",
    "SORTIMENT_LIST_KOD": "Kod",
    "SORTIMENT_LIST_NAMN": "Namn",
    "SORTIMENT_LIST_PRODUKTGRUPP": "Produktgrupp",
    "SORTIMENT_LIST_SOK": "Sök sortiment",
    "PRODUKTIONSOMRADEN": "Produktionsområden",
    "START_HEADER": "Start",
    "STATE_about": "Om RASK",
    "STATE_anvandare": "Användare",
    "STATE_anvandare.detail": "Detaljer",
    "STATE_featureinactivated": "Sida avaktiverad",
    "STATE_handelssortiment": "Handelssortiment",
    "STATE_handelssortimentDetail": "Detaljer",
    "STATE_inmatning": "Inmätning",
    "STATE_invalidurl": "Felaktig länk",
    "STATE_justeraleveransplan": "Justera leveransplan",
    "STATE_kund": "Kunder",
    "STATE_ckleverantor": "CK Leverantörer",
    "STATE_kund-new": "Kunder",
    "STATE_kund.detail": "Detaljer",
    "STATE_kundorder": "Kundorder",
    "STATE_kundorderDetail": "Kundorder Detaljer",
    "STATE_kundorderDetailCopy": "Kopiera Kundorder",
    "STATE_lagermal": "Lagermål",
    "STATE_leverantorsorder": "Leverantörsorder",
    "STATE_leverantorsorderDetail": "Leverantörsorder Detaljer",
    "STATE_login": "Logga in",
    "STATE_mattslagskonvertering": "Måttslagskonvertering",
    "STATE_maintenance": "Underhåll",
    "STATE_meddelandeInfotavla": "Systemaktivitet",
    "STATE_minamaskinlag": "Mina maskinlag",
    "STATE_aptering_sandningslogg": "Sändningslogg",
    "STATE_aptering_produktinstruktioner": "Produktinstruktioner",
    "STATE_aptering_produktinstruktioner_detail": "Produktinstruktion detaljer",
    "STATE_aptering_produktinstruktioner_massedit": "Massändra produktinstruktioner",
    "STATE_mottagningsplats": "Mottagningsplats",
    "STATE_mottagningsplats-new": "Mottagningsplats",
    "STATE_mottagningsplats.detail": "Detaljer",
    "STATE_mottagningsplatsdetail-new": "Detaljer",
    "STATE_mottagningsplatsdetailutland-new": "Detaljer",
    "STATE_mottagningsplats.detailutland": "Detaljer",
    "STATE_integration": "Integration",
    "STATE_integrationViol2": "Viol2",
    "STATE_migration.detail": "Detaljer",
    "STATE_permissiondenied": "Behörighet saknas",
    "STATE_permissiontoraskdenied": "Behörighet till Rask saknas",
    "STATE_planera": "Planera",
    "STATE_produkt": "Produkt",
    "STATE_produkt-detail": "Detaljer",
    "STATE_produktionsmal": "Produktionsmål",
    "STATE_produktionsomrade": "Produktionsomraden",
    "STATE_root": "RASK",
    "STATE_regelverkviol": "Regelverk",
    "STATE_regelverkviol3": "Regelverk",
    "STATE_sokexternkontrakt": "Importerade kontrakt",
    "STATE_sortiment": "Sortiment",
    "STATE_sortiment.detail": "Detaljer",
    "STATE_start": "Start",
    "STATE_systemadministration": "Systemadministration",
    "STATE_terminalorder": "Terminalorder",
    "STATE_terminalorderDetail": "Terminalorder Detaljer",
    "STATE_terminalorderDetailCopy": "Kopiera Terminalorder",
    "STATE_transportforetag": "Transportföretag",
    "STATE_transportforetagDetail": "Detaljer",
    "STATE_verksamhetsomrade": "Verksamhetsområden - Hantera",
    "STATE_virkeskopanbudkontrakt": "Anbud & kontrakt",
    "STATE_virkeskopavtal": "Detaljer (ny)",
    "STATE_virkeskopanbudkontraktDetail": "Detaljer",
    "STATE_virkesleverantor": "Leverantörer",
    "STATE_virkesleverantor-new": "Leverantörer",
    "STATE_virkesleverantor.detail": "Detaljer",
    "STATE_virkeskopminahandelssortiment": "Mina handelssortiment",
    "STATE_marknadsprislista": "Marknadsprislistor",
    "STATE_marknadsprislista.detail": "Ändra",
    "STATE_overvakning": "Övervakning",
    "STATE_overvakning.detail": "Detaljer",
    "STATE_jobb": "Jobb",
    "STATE_jobbDetail": "Jobb detaljer",
    "STATE_rebus": "Rebus",
    "STATE_minaproduktionsmallar": "Mina produktionsmallar",
    "STATE_virkesorder": "Virkesorder",
    "STATE_minaforkalkylsmallar": "Mina förkalkylsmallar",
    "STATE_terminal": "Terminal och Centrala köp",
    "STATE_terminal-details": "Terminal och Centrala köp",
    "STATE_transportplanera": "Transportplanera",
    "STATE_destineringsomraden": "Destineringsområden",
    "STATE_virkesorder-preview": "Granska virkesorder",
    "STATE_viol3-preview": "Granska viol3 data",
    "STATE_sokexternarbetsorder": "Sök extern arbetsorder",
    "STATE_externarbetsorder-details": "Extern arbetsorder detaljer",
    "STATE_externarbetsorder-details-viol2": "Extern arbetsorder detaljer",
    "STATE_rebusDetail": "Rebus messages",
    "STATE_ckproduktionsmall": "Produktionsmallar",
    "SYSTEMADMINISTRATION_HEADER": "Systemadministration",
    "TERMINALORDER_DETAIL_BUTTON_CREATE_NEW_TERMINALORDERRAD": "Lägg till ny terminalorderrad",
    "TERMINALORDER_DETAIL_BUTTON_DELETE_ORDERRAD": "Ta bort",
    "TERMINALORDER_DETAIL_BUTTON_SKAPA_TERMINALORDER": "Skapa terminalorder",
    "TERMINALORDER_DETAIL_BUTTON_SPARA_TERMINALORDER": "Spara terminalorder",
    "TERMINALORDER_DETAIL_DELETE_PROMPT_HEADER": "Radera terminalorder",
    "TERMINALORDER_DETAIL_DELETE_PROMPT_TEXT": "Bekräfta radering av terminalorder",
    "TERMINALORDER_DETAIL_EDITERA": "Terminalorder",
    "TERMINALORDER_DETAIL_INTERN_KUNDNAMN": "Sveaskog AB",
    "TERMINALORDER_DETAIL_KUND": "Internkund",
    "TERMINALORDER_DETAIL_KUND_VALIDATION": "Du måste ange internkund",
    "TERMINALORDER_DETAIL_KUNDORDERRAD_DELETE_MINSTENRAD": "Terminalorderraden kan inte tas bort, minst en rad på ordern",
    "TERMINALORDER_DETAIL_KUNDORDERRAD_DELETE_PERIODPABORJAD": "Terminalorderraden kan inte tas bort, eftersom dess period är påbörjad",
    "TERMINALORDER_DETAIL_KUNDORDERRAD_DELETE_PROMPT_HEADER": "Ta bort terminalorderrad",
    "TERMINALORDER_DETAIL_KUNDORDERRAD_DELETE_PROMPT_TEXT": "Vill du verkligen ta bort terminalorderraden med perioden ",
    "TERMINALORDER_DETAIL_HANDELSSORTIEMENT": "Handelssortiment",
    "TERMINALORDER_DETAIL_MOTTAGNINGSPLATS": "Terminal",
    "TERMINALORDER_DETAIL_MOTTAGNINGSPLATS_VALIDATION": "Du måste ange terminal",
    "TERMINALORDER_DETAIL_ORDERRAD": "terminalorderrad",
    "TERMINALORDER_DETAIL_SKAPA_NY": "Skapa ny terminalorder",
    "TERMINALORDER_DETAIL_SKAPA_TERMINALORDER": "Skapa terminalorderrad",
    "TERMINALORDER_DETAIL_TITLE_NEW_ORDERRAD": "Ny terminalorderrad",
    "TERMINALORDER_DETAIL_LAGG_TILL": "Lägg till ny terminalorderrad",
    "TERMINALORDER_HEADER": "Terminalorder",
    "TERMINALORDER_HEADER_PREVIEW": "Terminalorder (New)",
    "TERMINALORDER_LIST_HEADER_MOTTAGNINGSPLATS": "Terminal",
    "TERMINALORDER_LIST_KUND": "Internkund",
    "TERMINALORDER_LIST_MOTTAGNINGSPLATS": "Terminal (mottagningsplats)",
    "TERMINALORDER_LIST_SKAPA_NY": "Skapa ny terminalorder",
    "TERMINALORDER_LIST_SOK": "Sök terminalorder",
    "TERMINALORDER_UNDO_ORDER": "Ångra ändringar",
    "TRANSPORT_HEADER": "Transport",
    "TRANSPORTPLANERA_HEADER": "Transportplanera",
    "TPL_SOK_HEADER": "Sök arbetsorder",
    "TPL_SOK_GEOGRAFI": "Geografi",
    "TPL_SOK_TRANSPORTSATT": "Transportsätt",
    "TPL_SOK_TRANSPORTTIDSPANN_RUNDVIRKE": "Transporttidspann / Period (min - max)",
    "TPL_SOK_TRANSPORTTIDSPANN_BRANSLE": "Transporttidspann (min - max)",
    "TPL_SOK_ENMANAD": "en månad",
    "TPL_SOK_ETTKVARTAL": "ett kvartal",
    "TPL_SOK_PERIODTYP": "Period typ",
    "TPL_SOK_INGA_ARBETSORDRAR": "Hittade inga arbetsordrar",
    "TPL_LIST_HEADER": "Aktuella arbetsordrar",
    "TPL_LIST_VISA": "Visas i karta",
    "TPL_LIST_SELECT_ALL": "Välj alla",
    "TPL_FILTER_HEADER": "Filtrera",
    "TPL_FILTER_MASKINLAG": "Maskinlag",
    "TPL_FILTER_ANSKAFFNINGSFORM": "Anskaffningsform",
    "TPL_FILTER_HANDELSSORTIMENT": "Handelssortiment",
    "TPL_FILTER_TRANSPORTFORETAG": "Transportföretag",
    "TPL_FILTER_ARBETSORDERSTATUS": "AO Status",
    "TPL_FILTER_TRANSPORTTILLDELAD": "Transporttilldelad",
    "TPL_FILTER_TRANSPORTHANDELSE": "Transporthändelse",
    "TPL_FILTER_MOTTAGNINGSPLATS": "Mottagningsplats",
    "TPL_FILTER_VOLYM_PER_HS": "Volym per HS M3FUB (min - max)",
    "TPL_FILTER_AVSTAND": "Avstånd (min - max)",
    "TPL_FILTER_DESTINERAD": "Destinerad",
    "TPL_FILTER_TILLGANGLIGHET_VAG": "Tillgänglighet väg",
    "TPL_FILTER_FRITEXT": "Fritextsök",
    "TPL_UNCHANGEABLE_ARBETAORDRAR": "Följande arbetsordrar kan ej tilldelas pga av dessa är tilldelade på handelssortimentsnivå:",
    "TPL_FILTER_FILTRERA": "Filtrera",
    "TPL_FILTER_YES": "Ja",
    "TPL_FILTER_NO": "Nej",
    "TPL_FILTER_PLANED": "Planerad",
    "TPL_FILTER_ONGOING": "Pågående",
    "TPL_FILTER_VAGLAGER": "Väglager",
    "TPL_FILTER_LAGERALDER": "Lagerålder (min - max)",
    "TPL_DESTINERA_BUTTON": "Destinera",
    "TPL_HANTERAARBETSORDRAR_HEADER": "Hantera arbetsordrar",
    "TPL_TRANSPORTTILLDELA_HEADER": "Transporttilldela",
    "TPL_TRANSPORTTILLDELA_TRANSPORTTILLDELNING": "Transporttilldelning",
    "TPL_TRANSPORTTILLDELA_TILLDELA": "Tilldela",
    "TPL_TRANSPORTTILLDELA_REMOVE_TILLDELNING": "Ta bort tilldelning",
    "TPL_TRANSPORTTILLDELA_CONFIRM_TABORT_TITLE": "Bekräfta",
    "TPL_TRANSPORTTILLDELA_CONFIRM_TABORT_MESSAGE": "Ta bort tilldelning på valda arbetsordrar?",
    "TPL_TRANSPORTTILLDELA_ARBETSORDERNIVA": "Transporttilldela arbetsordern",
    "TPL_TRANSPORTTILLDELA_DELA_UPP_I_HS": "Dela upp i handelssortiment",
    "TPL_TRANSPORTTILLDELA_ANDRING_VO_VALS": "Denna arbetsorder har en Aktiv gammal VALS-virkesorder. Planera om i RASK för att ändringen av transportföretag ska få full effekt.",
    "TPL_TRANSPORTTILLDELA_ANDRING_VO_VALS_MULTIPLE": "Arbetsordrarna har en Aktiv gammal VALS-virkesorder. Planera om i RASK för att ändringen av transportföretag ska få full effekt: ",
    "TPL_TRANSPORTTILLDELA_VALSTOOLTIP": "Virkesordern är en Aktiv gammal VALS virkesorder. Planera om i RASK för att ändringen av transportföretag ska få full effekt.",
    "TPL_TRANSPORTTILLDELA_VALS_DETAILS": "Virkesordern är en Aktiv gammal VALS virkesorder. Planera om i RASK för att ändringen av transportföretag ska få full effekt.",
    "TPL_DESTINERA_HEADER": "Destinera",
    "TPL_DESTINERA_M3FUB": "m3f",
    "TPL_DESTINERA_MODAL_HEADER": "Destinering",
    "TPL_DESTINERA_MODAL_HANDELSSORTIMENT": "Handelssortiment",
    "TPL_DESTINERA_MODAL_SUMMAVOLYM": "Summa volym",
    "TPL_DESTINERA_MODAL_MOTTAGNINGSPLATS": "Mottagningsplats",
    "TPL_DESTINERA_MODAL_ANDEL": "Andel",
    "TPL_DESTINERA_MODAL_LAGGTILLMOTTAGNINGSPLATS": "Lägg till mottagningsplats",
    "TPL_DESTINERA_EJDESTINERAD_TOOLTIP": "Det gick inte att destinera denna AO till vald(a) mottagningsplats(er)",
    "TPL_DESTINERA_UPPDATERA_DESTINERINGSALTERNATIV": "Uppdatera destineringsalternativ",
    "TPL_DESTINERA_EJDESTINERAD_DETAILS": "Det gick inte att destinera denna AO till vald(a) mottagningsplats(er)",
    "TPL_HANDELSER_HEADER": "Händelser",
    "TPL_TOOLTIP_SOK": "Sök arbetsordrar",
    "TPL_TOOLTIP_FILTRERA": "Filtrera",
    "TPL_TOOLTIP_ARBETSORDERLISTA": "Lista av aktiva arbetsordrar",
    "TPL_TOOLTIP_TRANSPORTTILLDELA": "Transporttilldela",
    "TPL_TOOLTIP_DESTINERA": "Destinera",
    "TPL_TOOLTIP_HANDELSER": "Händelser",
    "TPL_TOOLTIP_HANTERAARBETSORDRAR": "Hantera arbetsordrar",
    "TPL_AODETAILS_RELATERAD_GROT_ARBETSORDER": "RELATERAD AO GROT",
    "TPL_AODETAILS_RELATERAD_RV_ARBETSORDER": "RELATERAD AO RUNDVIRKE",
    "TPL_AODETAILS_TILLGANGLIGHET_SKOG": "Skog",
    "TPL_AODETAILS_TILLGANGLIGHET_VAG": "Väg",
    "TPL_AODETAILS_LEVERANTOR": "Leverantör",
    "TPL_AODETAILS_VIRKESKOPARE": "Virkesköpare",
    "TPL_AODETAILS_VO_STATUS": "Virkesorderstatus",
    "TPL_AODETAILS_VIOL3_STATUS": "Viol3 status",
    "TPL_AODETAILS_MASKINLAG": "Maskinlag",
    "TPL_AODETAILS_SKORDNINGSSTATUS": "Skördningsstatus",
    "TPL_AODETAILS_SKOTNINGSSTATUS": "Skotningsstatus",
    "TPL_AODETAILS_TRANSPORTSTATUS": "Transportstatus",
    "TPL_AODETAILS_HANDELSSORTIMENT": "Handelssortiment",
    "TPL_AODETAILS_PLANERAD": "Planerat (m3f)",
    "TPL_AODETAILS_VAGLAGER": "Väglager (m3f)",
    "TPL_AODETAILS_SKOGSLAGER": "Skogslager (m3f)",
    "TPL_AODETAILS_TRANSPORTFORETAG": "Transportforetag",
    "TPL_AODETAILS_TRANSPORTAVSTAND": "Transportavstånd",
    "TPL_AODETAILS_TRANSPORTTIDSPAN": "Transporttidsspann",
    "TPL_AODETAILS_MOTTAGNINGSPLATS": "Destinerad Mottagningsplats",
    "TPL_AODETAILS_VALBARA_MOTAGNINGSPLATSER": "Valbara Mottagningsplatser",
    "TPL_AODETAILS_INGA_VALBARA_MOTAGNINGSPLATSER": "Hittade inga valbara mottagningsplatser",
    "TRANSPORTFORETAG_DETAIL_AKTIV": "Aktiv",
    "TRANSPORTFORETAG_DETAIL_BESOKSADRESS": "Besöksadress",
    "TRANSPORTFORETAG_DETAIL_BUTTON_KARTFUNKTIONER": "Kartfunktioner",
    "TRANSPORTFORETAG_DETAIL_BUTTON_RITA_HUVUDOMRADE": "Rita huvudområde",
    "TRANSPORTFORETAG_DETAIL_BUTTON_SPARA_UPPGIFTER": "Spara uppgifter",
    "TRANSPORTFORETAG_DETAIL_CERTIFIERINGSDATUM": "Certifieringsdatum",
    "TRANSPORTFORETAG_DETAIL_CERTIFIKAT": "Certifikat",
    "TRANSPORTFORETAG_DETAIL_FAKTURERINGSADRESS": "Faktureringsadress",
    "TRANSPORTFORETAG_DETAIL_HEADER_HUVUDOMRADE": "Huvudområde",
    "TRANSPORTFORETAG_DETAIL_HUVUDKOD": "Huvudkod",
    "TRANSPORTFORETAG_DETAIL_HUVUDTRANSPORTÖR": "Huvudtransportör",
    "TRANSPORTFORETAG_DETAIL_INTERNNR": "Internnr",
    "TRANSPORTFORETAG_DETAIL_LIMEID": "Lime-ID",
    "TRANSPORTFORETAG_DETAIL_LINK_BESKAR_HUVUDOMRADE": "Beskär huvudområde",
    "TRANSPORTFORETAG_DETAIL_LINK_KOMPLETTERA_HUVUDOMRADE": "Komplettera huvudområde",
    "TRANSPORTFORETAG_DETAIL_NAMN": "Namn",
    "TRANSPORTFORETAG_DETAIL_ORGANISATIONSNUMMER": "Organisationsnummer",
    "TRANSPORTFORETAG_HEADER": "Transportföretag",
    "DESTINERINGSOMRADEN_HEADER": "Destineringsområden",
    "DESTINERINGSOMRADEN_TOOLTIP_SOK": "Sök destineringsområden",
    "DESTINERINGSOMRADEN_TOOLTIP_EDITERA": "Redigera destineringsområde",
    "DESTINERINGSOMRADEN_SOK_HEADER": "Sök destineringsområden",
    "DESTINERINGSOMRADEN_SOK_INGA_OMRADEN": "Hittade inga destineringsområden",
    "DESTINERINGSOMRADEN_EDITERA_HEADER": "Destineringsområde",
    "DESTINERINGSOMRADEN_HANDELSSORTIMENT": "Handelssortiment",
    "DESTINERINGSOMRADEN_MOTTAGNIGSPLATS": "Mottagningsplats",
    "DESTINERINGSOMRADEN_FRITEXT": "Fritext",
    "DESTINERINGSOMRADEN_AKTIV": "Aktiv",
    "DESTINERINGSOMRADEN_NYTT_OMRADE": "Nytt destineringsområde",
    "DESTINERINGSOMRADEN_EDIT_NAMN": "Namn",
    "DESTINERINGSOMRADEN_FARG": "Färg",
    "DESTINERINGSOMRADEN_SKAPA_NYTT": "Skapa nytt destineringsområde",
    "DESTINERINGSOMRADEN_INGET_VALT": "Rita ett nytt område eller klicka på ett befintligt",
    "UNDERHALL_HEADER": "Underhåll",
    "VALIDATION_BUTTON_DONE": "Stäng",
    "VALIDATION_BUTTON_FORCE": "Fortsätt",
    "VALIDATION_BUTTON_COPY": "Kopiera till urklipp",
    "VALIDATION_HEADER": "Valideringsresultat",
    "VALIDATION_MESSAGE": "Meddelande",
    "VALIDATION_SEVERITY": "Nivå",
    "WARNING_HEADER": "Varning",
    "SERVERMESSAGE_HEADER": "Resultat",
    "VERKSAMHETSOMRADE_HANTERA": "Hantera verksamhetsområden",
    "VERKSAMHETSOMRADE_HEADER": "Verksamhetsområden",
    "VERKSAMHETSOMRADE_LABEL_DISTRIKT": "Distrikt (LKD)",
    "VERKSAMHETSOMRADE_LABEL_FORSAMLING": "Församlingar (LKF)",
    "VERKSAMHETSOMRADE_LABEL_VERKSAMHETSOMRADEN": "Verksamhetsområden",
    "VERKSAMHETSOMRADE_MSG_UPLOAD_ERROR": "Uppladdningen misslyckades",
    "VERKSAMHETSOMRADE_PO_BO_CREATE": "'Skapa produktionsområde Bergslagen Öst' schemalagt jobb.Id: ",
    "VERKSAMHETSOMRADE_PO_BO_ERROR": "Produktionsområde Bergslagen Öst går ej att skapa",
    "VERKSAMHETSOMRADE_RO_MIGRATE": "'Omorganisation2021_BergslagenSteg3Command' schemalagt jobb.Id: ",
    "VERKSAMHETSOMRADE_RO_MIGRATE_ERROR": "Omorganisation2021_BergslagenSteg3Command går ej schemalägga",
    "VERKSAMHETSOMRADE_MSG_UPLOAD_INFO": "Uppladdning av shapefil",
    "UTFORD": "Utförd:",
    "UTSKRIFT_SKRIV_UT": "Skriv ut",
    "UTSKRIFT_INKLUDERA": "Inkludera i utskrift",
    "UTSKRIFT_KONTRAKT": "Kontrakt",
    "UTSKRIFT_KARTOR": "Kartor",
    "UTSKRIFT_VARDEBERAKNING": "Värdeberäkning",
    "UTSKRIFT_SKAPA_UTSKRIFTER": "Skapa utskrifter",
    "UTSKRIFT_SENAST_SKAPADE": "Senast skapade utskrifter",
    "UTSKRIFT_INKLUDERA_VALJ_ALTERNATIV": "Ingen av alternativen valda. Välj minst en att skriva ut",
    "UTSKRIFT_SKAPA_INAKTIVERAD_SPARA": "Kontraktet måste vara sparat för att skapa utskrifter",
    "DOKUMENT_VERSION": "Version",
    "TEXT_EXPANDER_SHOW_MORE": "Läs mer",
    "TEXT_EXPANDER_SHOW_LESS": "Dölj",
    "DEV": "Lokalmiljö",
    "UTV": "Utvecklingsmiljö",
    "TEST": "Testmiljö",
    "DEMO": "Demomiljö",
    "ACCTEST": "Acceptanstestmiljö"
}
